var bundleProduct = function () {
  var shopifyFileUrl = "//www.explorethousand.com/cdn/shop/files/?v=135619";
  var baseFilePath = shopifyFileUrl.split("?")[0];
  var assetsoldoutUrl = "//www.explorethousand.com/cdn/shop/t/530/assets/soldout_small.png?v=26608208942692023401778782832";
  let currency = getCookie("cart_currency");

  // for helmet
  let selected_helmet = "bike-helmet";
  let selected_helmet_product_details = "";
  let selected_helmet_varient_color = "";
  let selected_helmet_varient_size = "";
  let selected_helmet_varient_details = "";

  // for monogram
  let maxLengthMonogram = "";
  let selected_monogram_product_details = "";
  let selected_helmet_varient_monogram_image = "";
  let selected_monogram_initials = "";

  // for visor
  let already_added_visor = {
    "Club Navy": { name: "Tortoise Shell" },
    "Racer Black": { name: "Matte Black" },
    "Supermoon White": { name: "Rose Gold" },
    "CHPT3 x Thousand Barrivell": { name: "Iridescent Metallic" },
    "Skyline Grey": { name: "Glossy Black" },
  };
  let already_added_visor_details = "";
  let visor_all_images = "";
  let selected_visor_varient_details = "";
  let selected_helmet_varient_visor_image = "";

  // for locks
  let selected_locks_varient_details = "";

  // for lights
  let selected_lights_varient_details = "";

  // light varients
  let set_light_varients = [41035518246959, 41035518312495, 41035518378031];
  let all_light_varients = [
    41035501633583, 41035518214191, 41035501666351, 41035518279727,
    41035501699119, 41035518345263,
  ];

  // for gloves
  let selected_glove_varient_details = "";

  // golove varients
  let little_courier_glove = [
    31680495255599, 31680495288367, 31680495321135, 31680495353903,
    31680495386671, 31680495419439,
  ];
  let defrance_glove = [31680495452207, 31680495484975, 31680495517743];
  let bullitt_glove = [31680495157295, 31680495190063, 31680495222831];

  // for bells
  let selected_bells_varient_details = "";
  let selected_bells_varient_handle = "";

  // for socks
  let selected_socks_varient_details = "";
  let selected_socks_varient_handle = "";

  // for gaiter
  let selected_gaiter_varient_details = "";
  let selected_gaiter_varient_handle = "";

  // for remixgloves
  let selected_remixgloves_varient_details = "";
  let selected_remixgloves_varient_handle = "";

  // for stickers
  let already_added_sticker_details = "";
  let selected_sticker_varient_details = "";
  let selected_sticker_varient_handle = "";

  let selected_bells_sticker_variation = "";
  let selected_socks_variation = "";
  let selected_gaiter_variation = "";
  let products_kit = {
    "bike-helmet": {
      helmets: "bike-helmet",
      monogram: "monogram",
      gloves: "bike-gloves",
      bells: "bike-bell",
      socks: "remix-socks",
      gaiter: "remix-gaiter",
      remixgloves: "remix-gloves",
      stickers: "helmet-stickers",
      lights: "bike-lights",
      locks: {
        0: "u-lock-bike-lock",
        1: "cable-bike-lock",
      },
    },
    "mips-helmet": {
      helmets: "mips-helmet",
      visor: "chapter-visors",
      gloves: "bike-gloves",
      bells: "bike-bell",
      socks: "remix-socks",
      gaiter: "remix-gaiter",
      remixgloves: "remix-gloves",
      stickers: "helmet-stickers",
      lights: "bike-lights",
      locks: {
        0: "u-lock-bike-lock",
        1: "cable-bike-lock",
      },
    },
    "kids-helmet": {
      helmets: "kids-helmet",
      monogram: "thousand-jr-monogram",
      bells: "kids-bell",
      socks: "remix-socks",
      gaiter: "remix-gaiter",
      remixgloves: "remix-gloves",
      stickers: "kids-stickers",
      lights: "bike-lights",
      locks: {
        0: "u-lock-bike-lock",
        1: "cable-bike-lock",
      },
    },
  };

  let current_tab = "helmets";
  let next_tab;
  let prev_tab;

  let inv_location = getCookie("user_location_warehouse");

  let edited_products = {};
  let edited_products_ids = [];
  let edited_bundle_position = "";

  var all_helmets = false;

  var mips_helmet = false;
  var bike_helmet = false;
  var kids_helmet = false;

  init();

  function init() {
    setCookie("bundle_cart_elements", "", 30);
    show_loader();
    if (!$("body").hasClass("is-usa")) {
      $("ul.kit-selector li")
        .find("[data-kit-tab='monogram']")
        .parent("li")
        .remove();
      $("ul.kit-selector li")
        .find("[data-kit-tab='lights']")
        .parent("li")
        .remove();
      $("ul.kit-selector li")
        .find("[data-kit-tab='locks']")
        .parent("li")
        .remove();
    }
    // check if kit is edit mode and change selected_helmet value
    var edit_bundle = check_edit_kit_mode();
    if (edit_bundle != null) {
      get_cart_items(edit_bundle);
    } else {
      get_cart_items("");
      $(".kit-selector li").addClass("show");
      $('.kit-selector li:not(".' + selected_helmet + '")')
        .removeClass("show")
        .addClass("hide");
      set_next_tab();
      get_product_info(selected_helmet, true);
    }
    $('.kit-next-btn').attr('disabled', true).text('Select a Helmet')
  }

  function get_cart_items(edit_bundle) {
    $.ajax({
      url: "/cart.js",
      dataType: "json",
      cache: false,
      success: function (cart) {
        if (cart.item_count > 0) {
          $.each(cart.items, function (index, item) {
            if (item.handle == "mips-helmet") {
              mips_helmet = true;
            } else if (item.handle == "bike-helmet") {
              bike_helmet = true;
            } else if (item.handle == "kids-helmet") {
              kids_helmet = true;
            }
            if (
              typeof item.properties._btype != "undefined" &&
              item.properties._btype == edit_bundle
            ) {
              edited_products[item.properties._ptype] = item;
              edited_products_ids.push(item.variant_id);
              edited_bundle_position = item.properties._bposition;
            }
          });
        }

        if (edit_bundle != "") {
          selected_helmet =
            typeof edited_products.helmets != "undefined"
              ? edited_products.helmets.handle
              : selected_helmet;
          $(".kit-product-img")
            .find('input[name=main-helmet][value="' + selected_helmet + '"]')
            .click();
          show_bundle_images();
        }

        cart_products = cart;
      },
    });
  }

  function show_bundle_images() {
    console.log("show_bundle_images", edited_products);
    if (typeof edited_products.helmets != "undefined") {
      if (
        typeof edited_products.helmets.image != "undefined" &&
        edited_products.helmets.image != ""
      ) {
        var helmet_image =
          '<span class="builder-bg-img kit-helmet-image kit-product-image1"><img class="kit-helmet" src="' +
          edited_products.helmets.image +
          '"></span>';
        $(".kit-builder-img").append(helmet_image);
      }
    }

    if (typeof edited_products.monogram != "undefined") {
      if (
        typeof edited_products.monogram.properties._image != "undefined" &&
        edited_products.monogram.properties._image != ""
      ) {
        selected_helmet_varient_monogram_image =
          edited_products.monogram.properties._image;
        set_monogram_image();
        updateMonogramImage(
          edited_products.monogram.variant_options[0],
          edited_products.monogram.variant_options[1]
        );
      }
    }

    if (typeof edited_products.visor != "undefined") {
      if (
        typeof edited_products.visor.properties._image != "undefined" &&
        edited_products.visor.properties._image != ""
      ) {
        var visor_image =
          '<span class="builder-bg-img kit-visor-image kit-product-image2"><img class="kit-helmet" src="' +
          edited_products.visor.properties._image +
          '"></span>';
        $(".kit-builder-img").append(visor_image);
      }
    }

    if (typeof edited_products.lights != "undefined") {
      if (
        typeof edited_products.lights.image != "undefined" &&
        edited_products.lights.image != ""
      ) {
        var lights_image =
          '<span class="builder-bg-img kit-lights-image kit-product-image6"><img class="kit-helmet" src="' +
          edited_products.lights.image +
          '"></span>';
        $(".kit-builder-img").append(lights_image);
      }
    }

    if (typeof edited_products.locks != "undefined") {
      if (
        typeof edited_products.locks.image != "undefined" &&
        edited_products.locks.image != ""
      ) {
        var locks_image =
          '<span class="builder-bg-img kit-locks-image kit-product-image7"><img class="kit-helmet" src="' +
          edited_products.locks.image +
          '"></span>';
        $(".kit-builder-img").append(locks_image);
      }
    }

    if (typeof edited_products.gloves != "undefined") {
      if (
        typeof edited_products.gloves.image != "undefined" &&
        edited_products.gloves.image != ""
      ) {
        var gloves_image =
          '<span class="builder-bg-img kit-gloves-image kit-product-image3"><img class="kit-helmet" src="' +
          edited_products.gloves.image +
          '"></span>';
        $(".kit-builder-img").append(gloves_image);
      }
    }

    if (typeof edited_products.bells != "undefined") {
      if (
        typeof edited_products.bells.image != "undefined" &&
        edited_products.bells.image != ""
      ) {
        var bells_image =
          '<span class="builder-bg-img kit-bells-image kit-product-image4"><img class="kit-helmet" src="' +
          edited_products.bells.image +
          '"></span>';
        $(".kit-builder-img").append(bells_image);
      }
    }

    if (typeof edited_products.socks != "undefined") {
      if (
        typeof edited_products.socks.image != "undefined" &&
        edited_products.socks.image != ""
      ) {
        var socks_image =
          '<span class="builder-bg-img kit-socks-image kit-product-image4"><img class="kit-helmet" src="' +
          edited_products.socks.image +
          '"></span>';
        $(".kit-builder-img").append(socks_image);
      }
    }

    if (typeof edited_products.gaiter != "undefined") {
      if (
        typeof edited_products.gaiter.image != "undefined" &&
        edited_products.gaiter.image != ""
      ) {
        var gaiter_image =
          '<span class="builder-bg-img kit-gaiter-image kit-product-image4"><img class="kit-helmet" src="' +
          edited_products.gaiter.image +
          '"></span>';
        $(".kit-builder-img").append(gaiter_image);
      }
    }

    if (typeof edited_products.remixgloves != "undefined") {
      if (
        typeof edited_products.remixgloves.image != "undefined" &&
        edited_products.remixgloves.image != ""
      ) {
        var remixgloves_image =
          '<span class="builder-bg-img kit-remixgloves-image kit-product-image4"><img class="kit-helmet" src="' +
          edited_products.remixgloves.image +
          '"></span>';
        $(".kit-builder-img").append(remixgloves_image);
      }
    }

    if (typeof edited_products.stickers != "undefined") {
      if (
        typeof edited_products.stickers.image != "undefined" &&
        edited_products.stickers.image != ""
      ) {
        var stickers_image =
          '<span class="builder-bg-img kit-stickers-image kit-product-image5"><img class="kit-helmet" src="' +
          edited_products.stickers.image +
          '"></span>';
        $(".kit-builder-img").append(stickers_image);
      }
    }
  }

  function set_next_tab() {
    next_tab = $("ul.kit-selector li.active")
      .nextAll("li:not(.hide)")
      .find("a")
      .data("kit-tab");
  }

  function set_prev_tab() {
    prev_tab = $("ul.kit-selector li.active")
      .prevAll("li:not(.hide)")
      .find("a")
      .data("kit-tab");
  }

  function check_edit_kit_mode() {
    //check if a kit product is being edited
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("btype");
  }

  function show_loader() {
    //show a loader
    $(".ths-loader").show();
  }

  function hide_loader() {
    //hide the loader
    $(".ths-loader").hide();
  }

  function get_product_info(handle, firstLoad) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        selected_helmet_product_details = product;

        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_size_min = false;
          option_index = i;

          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }

          if (
            o.name == "color" ||
            o.name == "Color" ||
            o.name == "colour" ||
            o.name == "Colour"
          ) {
            is_color_min = true;
          }

          bundle_html +=
            "<div class='bundle-product-options' data-varients='" +
            JSON.stringify(JSON.stringify(product.variants)) +
            "'>";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';
          bundle_html += '<div class="option_title">';
          bundle_html +=
            '<span class="swatch-type">' + o.name.toLowerCase() + "</span>";

          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-color-min"></span>';
          } else if (is_size_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-size-min"></span>';
          }

          bundle_html += "</div>";
          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle + "-swatch";
                } else if (is_color_min) {
                  var element_class = "color " + handle + "-swatch";
                }

                bundle_html += '<div class = "swatch-min-item">';
                if (is_size_min) {
                  bundle_html +=
                    '<input id="option-' +
                    v.id +
                    '" type="radio" data-value="' +
                    v[op_index] +
                    '" data-product_id="' +
                    product.id +
                    '" data-id="' +
                    v.id +
                    '" data-is-color="' +
                    is_color_min +
                    '" data-variant-name="' +
                    v.title +
                    '" name="product-option-' +
                    option_index +
                    '" value="' +
                    v[op_index] +
                    '" ' +
                    checked +
                    ' class="' +
                    soldClass +
                    '" />';
                } else {
                  bundle_html +=
                    '<input id="option-' +
                    v.id +
                    '" type="radio" data-value="' +
                    v[op_index] +
                    '" data-product_id="' +
                    product.id +
                    '" data-id="' +
                    v.id +
                    '" data-is-color="' +
                    is_color_min +
                    '" data-variant-name="' +
                    v.title +
                    '" name="product-option-' +
                    option_index +
                    '" value="' +
                    v[op_index] +
                    '" ' +
                    checked +
                    ' class="' +
                    soldClass +
                    '" data-image="' +
                    imageUrl +
                    '" />';
                }

                bundle_html +=
                  '<div data-id="' +
                  v.id +
                  '" class="swatch-min-element ' +
                  soldClass +
                  " " +
                  element_class +
                  '">';
                bundle_html += '<label for = "option-' + v.id + '">';
                if (is_size_min) {
                  if (v[op_index] == "Small") {
                    bundle_html +=
                      '<span class="swatch-display-min"> S </span>';
                  } else if (v[op_index] == "Medium") {
                    bundle_html +=
                      '<span class="swatch-display-min"> M </span>';
                  } else if (v[op_index] == "Large") {
                    bundle_html +=
                      '<span class="swatch-display-min"> L </span>';
                  } else if (v[op_index] == "Extra Small") {
                    bundle_html +=
                      '<span class="swatch-display-min"> XS </span>';
                  } else if (v[op_index] == "Extra Large") {
                    bundle_html +=
                      '<span class="swatch-display-min"> XL </span>';
                  }
                }
                bundle_html +=
                  '<img class="crossed-out" src="' + assetsoldoutUrl + '"/>';
                bundle_html += "</label>";
                bundle_html += "</div>";
                bundle_html += "</div>";
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        jQuery(".helmets-tab")
          .find("." + handle)
          .html(bundle_html);

        var fit_guid_id =
          selected_helmet == "kids-helmet"
            ? "size-guide-fit-helmet-jr"
            : "size-guide-fit-helmet";
        jQuery(".helmets-tab")
          .find(".see-fit-guide")
          .html(
            '<a href="javascript:void(0)" data-fancybox="fitguide" data-src="#' +
              fit_guid_id +
              '" class="size_chart">See Fit Guide</a>'
          );
        // jQuery('[data-fancybox="fitguide"]').fancybox({
        //   beforeShow: function(){
        //     console.log('size chart trig');
        //       jQuery("body").addClass('blocked-scroll');
        //   },
        //   afterClose: function(){
        //       jQuery("body").removeClass('blocked-scroll');
        //   },
        //   touch: {
        //     vertical : false,
        //     momentum : false
        //   }
        // });
        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery(".helmets-tab")
            .find(".about-helmet")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery(".helmets-tab").find(".about-helmet").html("");
        }
        let size = "";
        let color = "";
        jQuery(".helmets-tab")
          .find(".bundle-product-options")
          .each(function (i, obj) {
            $(obj)
              .find(".clearfix")
              .find("input")
              .first()
              .prop("checked", true);
            let varient_name = $(obj)
              .find(".clearfix")
              .find("input")
              .first()
              .data("value");
            let type = $(obj)
              .find(".clearfix")
              .find(".option_title .swatch-type ")
              .text();
            if ($(obj).find(".clearfix").hasClass("swatch-type-min-size")) {
              $(obj)
                .find(".clearfix")
                .find(".option_title .current-size-min")
                .text(varient_name);
              size = $(obj).find("input").first().val();
            } else if (
              $(obj).find(".clearfix").hasClass("swatch-type-min-color")
            ) {
              $(obj)
                .find(".clearfix")
                .find(".option_title .current-color-min")
                .text(varient_name);
              color = $(obj).find("input").first().val();
            }
          });

        if (typeof cart_bundle_cookie.helmet != "undefined") {
          $(".bundle-product-options")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.helmet.color +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options")
            .find(
              'input[name=product-option-1][value="' +
                cart_bundle_cookie.helmet.size +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.helmet.color +
                '"]'
            )
            .trigger("change");
          $(".bundle-product-options")
            .find(
              'input[name=product-option-1][value="' +
                cart_bundle_cookie.helmet.size +
                '"]'
            )
            .trigger("change");
        } else if (
          typeof edited_products.helmets != "undefined" &&
          edited_products.helmets.handle == selected_helmet
        ) {
          $(".bundle-product-options")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.helmets.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options")
            .find(
              'input[name=product-option-1][value="' +
                edited_products.helmets.variant_options[1] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.helmets.variant_options[0] +
                '"]'
            )
            .trigger("change");
          $(".bundle-product-options")
            .find(
              'input[name=product-option-1][value="' +
                edited_products.helmets.variant_options[1] +
                '"]'
            )
            .trigger("change");
        } else {
          var all_varients = product.variants;
          var image_url = "";
          var featuredVariantPosition = "";

          all_varients.forEach(function (item, index) {
            if (item.option1 == color && item.option2 == size) {
              selected_helmet_varient_details = item;
              image_url = item.featured_image.src;
              featuredVariantPosition = item.featured_image.position;
              selected_helmet_varient_color = item.option1;
              selected_helmet_varient_size = item.option2;
            }
            if (item.option1 == color) {
              if (kitBuilderInfo[item.id][inv_location] > 0) {
                $(".bundle-product-options")
                  .find(
                    'input[name=product-option-1][value="' + item.option2 + '"]'
                  )
                  .next()
                  .removeClass("soldout");
              } else {
                $(".bundle-product-options")
                  .find(
                    'input[name=product-option-1][value="' + item.option2 + '"]'
                  )
                  .next()
                  .addClass("soldout");
              }
            }
          });

          var itemPrice = formatMoneyStripTrailingZeros(
            selected_helmet_varient_details.price,
            $("body").data("money-format")
          );
          $(".all-helmets-select .product-price").text(itemPrice);

          if(!firstLoad){
            if (image_url != "" && typeof image_url != "undefined") {
              $(".kit-helmet-image").remove();
              var helmet_image =
                '<span class="builder-bg-img kit-product-image1 kit-helmet-image"><img class="kit-helmet" src="' +
                image_url +
                '"></span>';
              $(".kit-builder-img").append(helmet_image);
              $(".kit-product-image1").prependTo(".kit-builder-img");
            }
          }

          selected_helmet_varient_monogram_image =
            selected_helmet_product_details.images[featuredVariantPosition + 2];

          ValidateProductQtyForNextStep(
            selected_helmet_varient_details.id,
            "helmet"
          );
        }

        hide_loader();
      }
    );
  }

  // on helmet variation change
  $(document).on(
    "change",
    ".bundle-product-options input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      $(".ride-shop-bg").remove();
      var current_element = $(this);
      let image_url = $(this).data("image");

      let varient_name = $(this).data("value");
      let type = $(this)
        .parents(".bundle-product-options")
        .find(".option_title .swatch-type")
        .text();

      if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options")
          .find(".option_title .current-color-min")
          .text(varient_name);
      } else if (type == "Size" || type == "size") {
        $(this)
          .parents(".bundle-product-options")
          .find(".option_title .current-size-min")
          .text(varient_name);
      }

      let number_opts = $(this)
        .parents(".helmets-tab")
        .find(".bundle-product-options").length;
      let varient_id = "";
      let sold_out = false;
      let varients = $(this)
        .parents(".bundle-product-options")
        .data("varients");

      if (isJson(varients)) {
        varients = JSON.parse(JSON.parse(varients));
      }

      if (number_opts == 1) {
        varient_id = $(this).data("id");
        sold_out = $(this).hasClass("soldout") ? true : false;
      } else if (number_opts == 2) {
        let size = "";
        let color = "";
        var item_obj;

        $(current_element)
          .parents(".helmets-tab")
          .find(".bundle-product-options")
          .each(function (i, obj) {
            if ($(obj).find(".clearfix").hasClass("swatch-type-min-size")) {
              size = $(obj).find("input[name=product-option-1]:checked").val();
            } else if (
              $(obj).find(".clearfix").hasClass("swatch-type-min-color")
            ) {
              color = $(obj).find("input[name=product-option-0]:checked").val();
            }
          });

        var featuredVariantPosition = "";
        varients.forEach(function (item, index) {
          if (item.option1 == color && item.option2 == size) {
            selected_helmet_varient_details = item;
            featuredVariantPosition = item.featured_image.position;
            selected_helmet_varient_color = item.option1;
            selected_helmet_varient_size = item.option2;
          }

          if (item.option1 == color) {
            if (kitBuilderInfo[item.id][inv_location] > 0) {
              $(".bundle-product-options")
                .find(
                  'input[name=product-option-1][value="' + item.option2 + '"]'
                )
                .next()
                .removeClass("soldout");
            } else {
              $(".bundle-product-options")
                .find(
                  'input[name=product-option-1][value="' + item.option2 + '"]'
                )
                .next()
                .addClass("soldout");
            }
          }
        });

        var itemPrice = formatMoneyStripTrailingZeros(
          selected_helmet_varient_details.price,
          $("body").data("money-format")
        );
        $(".all-helmets-select .product-price").text(itemPrice);
      }

      if (image_url != "" && typeof image_url != "undefined") {
        $(".kit-helmet-image").remove();
        var helmet_image =
          '<span class="builder-bg-img kit-product-image1 kit-helmet-image"><img class="kit-helmet" src="' +
          image_url +
          '"><span>';
        $(".kit-builder-img").append(helmet_image);
        $(".kit-product-image1").prependTo(".kit-builder-img");
      }

      selected_helmet_varient_monogram_image =
        selected_helmet_product_details.images[featuredVariantPosition + 2];
      ValidateProductQtyForNextStep(
        selected_helmet_varient_details.id,
        "helmet"
      );
    }
  );

  //  get lights tab html
  function get_products_lights(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_light_min = false;
          option_index = i;

          if (o.name == "Light" || o.name == "light") {
            is_light_min = true;
            var e_class = "min-light-swatch-options";
          }

          if (o.name == "Color" || o.name == "color") {
            is_color_min = true;
            var e_class = "min-color-swatch-options";
          }

          bundle_html +=
            "<div class='bundle-product-options-lights' data-varients='" +
            JSON.stringify(JSON.stringify(product.variants)) +
            "'>";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-title-bundle">Choose your bike lights</span>';
          }

          bundle_html += '<div class="option_title">';
          bundle_html +=
            '<span class="swatch-type" data-name="' +
            o.name.toLowerCase() +
            '">' +
            o.name.toLowerCase() +
            "</span>";
          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-color-min"></span>';
          } else if (is_light_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-light-min"></span>';
          }

          if (is_color_min) {
            bundle_html +=
              '<span class="kit-builder-price light-price"> </span>';
          }

          bundle_html += "</div>";
          bundle_html += '<div class = "' + e_class + '">';

          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_color_min) {
                  var element_class = "color " + handle + "-swatch";
                } else if (is_light_min) {
                  var element_class = "light " + handle + "-swatch";
                }

                bundle_html += '<div class = "swatch-min-item">';
                bundle_html +=
                  '<input id="option-' +
                  v.id +
                  '" type="radio" data-value="' +
                  v[op_index] +
                  '" data-product_id="' +
                  product.id +
                  '" data-id="' +
                  v.id +
                  '" data-is-color="' +
                  is_color_min +
                  '" data-variant-name="' +
                  v.title +
                  '" name="product-option-' +
                  option_index +
                  '" value="' +
                  v[op_index] +
                  '" ' +
                  checked +
                  ' class="' +
                  soldClass +
                  '" data-image="' +
                  imageUrl +
                  '" />';
                bundle_html +=
                  '<div data-id="' +
                  v.id +
                  '" class="swatch-min-element ' +
                  soldClass +
                  " " +
                  element_class +
                  '">';
                bundle_html += '<label for = "option-' + v.id + '">';
                bundle_html += "</label>";
                bundle_html += "</div>";
                bundle_html += "</div>";
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        jQuery("#lights")
          .find("." + handle)
          .html(bundle_html);

        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery("#lights")
            .find(".about-bike-lights")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery("#lights").find(".about-bike-lights").html("");
        }

        let color = "";
        let light = "";
        jQuery("#lights")
          .find(".bundle-product-options-lights")
          .each(function (i, lightobj) {
            $(lightobj)
              .find(".clearfix")
              .find("input")
              .first()
              .prop("checked", true);
            let varient_name = $(lightobj)
              .find(".clearfix")
              .find("input")
              .first()
              .data("value");
            let type = $(lightobj)
              .find(".clearfix")
              .find(".option_title .swatch-type ")
              .text();
            if (
              $(lightobj).find(".clearfix").hasClass("swatch-type-min-color")
            ) {
              $(lightobj)
                .find(".clearfix")
                .find(".option_title .current-color-min")
                .text(varient_name);
              color = $(lightobj).find("input").first().val();
              $(lightobj).find("input").first().addClass("active");
            } else if (
              $(lightobj).find(".clearfix").hasClass("swatch-type-min-light")
            ) {
              $(lightobj)
                .find(".clearfix")
                .find(".option_title .current-light-min")
                .text(varient_name);
              light = $(lightobj).find("input").first().val();
            }
          });

        if (typeof cart_bundle_cookie.lights != "undefined") {
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.lights.color +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-1][value="' +
                cart_bundle_cookie.lights.light +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.lights.color +
                '"]'
            )
            .trigger("change");
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-1][value="' +
                cart_bundle_cookie.lights.light +
                '"]'
            )
            .trigger("change");
        } else if (typeof edited_products.lights != "undefined") {
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.lights.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-1][value="' +
                edited_products.lights.variant_options[1] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.lights.variant_options[0] +
                '"]'
            )
            .trigger("change");
          $(".bundle-product-options-lights")
            .find(
              'input[name=product-option-1][value="' +
                edited_products.lights.variant_options[1] +
                '"]'
            )
            .trigger("change");
        } else {
          var all_varients = product.variants;
          var image_url = "";
          console.log(color);
          console.log(light);

          all_varients.forEach(function (item, index) {
            if (item.option1 == color && item.option2 == light) {
              selected_lights_varient_details = item;
              image_url = item.featured_image.src;
              console.log(item);
            }

            if (item.option1 == color) {
              if (kitBuilderInfo[item.id][inv_location] > 0) {
                $(".bundle-product-options-lights")
                  .find(
                    'input[name=product-option-1][value="' + item.option2 + '"]'
                  )
                  .next()
                  .removeClass("soldout");
              } else {
                $(".bundle-product-options-lights")
                  .find(
                    'input[name=product-option-1][value="' + item.option2 + '"]'
                  )
                  .next()
                  .addClass("soldout");
              }
            }
          });

          console.log(image_url);

          if (image_url != "" && typeof image_url != "undefined") {
            $(".kit-lights-image").remove();
            var image_class = "kit-product-image6";
            var lights_image =
              '<span class="builder-bg-img kit-lights-image ' +
              image_class +
              '"><img class="kit-helmet" src="' +
              image_url +
              '"></span>';
            $(".kit-builder-img").append(lights_image);
          }

          var itemPrice =
            check_strikethrough_price_for_lights(cart_bundle_cookie);
          $("#lights .light-price").html(
            '<span class="money">' + itemPrice + "</strong></div></a></li>"
          );
          ValidateProductQtyForNextStep(
            selected_lights_varient_details.id,
            "lights"
          );
        }

        hide_loader();
      }
    );
  }

  function check_strikethrough_price_for_lights(cart_bundle_cookie) {
    var itemPrice;
    var strikethrough_discount = false;
    if (mips_helmet || bike_helmet || kids_helmet) {
      strikethrough_discount = true;
    } else if (typeof cart_bundle_cookie.helmet != "undefined") {
      strikethrough_discount = true;
    }
    var price = selected_lights_varient_details.price;
    var discount = false;
    if (
      strikethrough_discount &&
      strikethrough_discounted_price.set_light.dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      if (set_light_varients.includes(selected_lights_varient_details.id)) {
        price = strikethrough_discounted_price.set_light.dis_price;
        discount = true;
      } else {
        price = strikethrough_discounted_price.all_light.dis_price;
        discount = true;
      }
    }
    selected_lights_varient_details.bprice = price;
    var itemPrice = formatMoneyStripTrailingZeros(
      price,
      $("body").data("money-format")
    );
    if (discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(
          selected_lights_varient_details.price,
          $("body").data("money-format")
        ) +
        "</span>";
    }
    return itemPrice;
  }

  //  on light variation change ..
  $(document).on(
    "change",
    ".bundle-product-options-lights input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      $(".bundle-product-options-lights input[type=radio]").removeClass(
        "active"
      );
      $(this).addClass("active");

      var current_element = $(this);
      let varient_name = $(this).data("value");
      let type = $(this)
        .parents(".bundle-product-options-lights")
        .find(".option_title .swatch-type")
        .data("name");

      if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options-lights")
          .find(".option_title .current-color-min")
          .text(varient_name);
      } else if (type == "Light" || type == "light") {
        $(this)
          .parents(".bundle-product-options-lights")
          .find(".option_title .current-light-min")
          .text(varient_name);
      }

      let varients = $(this)
        .parents(".bundle-product-options-lights")
        .data("varients");
      if (isJson(varients)) {
        varients = JSON.parse(JSON.parse(varients));
      }

      let color = "";
      let light = "";
      var item_obj;
      let image_url = "";

      $(current_element)
        .parents("#lights")
        .find(".bundle-product-options-lights")
        .each(function (i, lightobj) {
          if ($(lightobj).find(".clearfix").hasClass("swatch-type-min-color")) {
            color = $(lightobj)
              .find("input[name=product-option-0]:checked")
              .val();
          } else if (
            $(lightobj).find(".clearfix").hasClass("swatch-type-min-light")
          ) {
            light = $(lightobj)
              .find("input[name=product-option-1]:checked")
              .val();
          }
        });

      varients.forEach(function (item, index) {
        if (item.option1 == color && item.option2 == light) {
          selected_lights_varient_details = item;
          image_url = item.featured_image.src;
        }
        if (item.option1 == color) {
          if (kitBuilderInfo[item.id][inv_location] > 0) {
            $(".bundle-product-options-lights")
              .find(
                'input[name=product-option-1][value="' + item.option2 + '"]'
              )
              .next()
              .removeClass("soldout");
          } else {
            $(".bundle-product-options-lights")
              .find(
                'input[name=product-option-1][value="' + item.option2 + '"]'
              )
              .next()
              .addClass("soldout");
          }
        }
      });

      if (image_url != "" && typeof image_url != "undefined") {
        $(".kit-lights-image").remove();
        var image_class = "kit-product-image6";
        var lights_image =
          '<span class="builder-bg-img kit-lights-image ' +
          image_class +
          '"><img class="kit-helmet" src="' +
          image_url +
          '"></span>';
        $(".kit-builder-img").append(lights_image);
      }

      var itemPrice = check_strikethrough_price_for_lights(cart_bundle_cookie);
      $("#lights .light-price").html(
        '<span class="money">' + itemPrice + "</strong></div></a></li>"
      );

      ValidateProductQtyForNextStep(
        selected_lights_varient_details.id,
        "lights"
      );
    }
  );

  // get locks tab html
  function get_products_locks(handle) {
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    if (typeof cart_bundle_cookie.locks != "undefined") {
      $(".bundle-product-options-locks")
        .find(
          'input[name=lock-product][value="' +
            cart_bundle_cookie.locks.handle +
            '"]'
        )
        .prop("checked", true);
      $(".bundle-product-options-locks")
        .find(
          'input[name=lock-product][value="' +
            cart_bundle_cookie.locks.handle +
            '"]'
        )
        .trigger("change");
    } else if (typeof edited_products.locks != "undefined") {
      $(".bundle-product-options-locks")
        .find(
          'input[name=lock-product][value="' +
            edited_products.locks.handle +
            '"]'
        )
        .prop("checked", true);
      $(".bundle-product-options-locks")
        .find(
          'input[name=lock-product][value="' +
            edited_products.locks.handle +
            '"]'
        )
        .trigger("change");
    } else {
      $(".bundle-product-options-locks")
        .find('input[name=lock-product][value="' + handle[0] + '"]')
        .prop("checked", true);
      $(".bundle-product-options-locks")
        .find('input[name=lock-product][value="' + handle[0] + '"]')
        .trigger("change");
    }
  }

  function check_strikethrough_price_for_locks(cart_bundle_cookie) {
    var itemPrice;
    var strikethrough_discount = false;
    if (mips_helmet || bike_helmet || kids_helmet) {
      strikethrough_discount = true;
    } else if (typeof cart_bundle_cookie.helmet != "undefined") {
      strikethrough_discount = true;
    }
    var handle = selected_locks_varient_details.handle;
    var price = selected_locks_varient_details.price;
    var discount = false;
    if (
      strikethrough_discount &&
      strikethrough_discounted_price[handle].dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      price = strikethrough_discounted_price[handle].dis_price;
      discount = true;
    }
    selected_locks_varient_details.bprice = price;
    var itemPrice = formatMoneyStripTrailingZeros(
      price,
      $("body").data("money-format")
    );
    if (discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(
          selected_locks_varient_details.price,
          $("body").data("money-format")
        ) +
        "</span>";
    }
    return itemPrice;
  }

  //  on locks product change ..
  $(document).on(
    "change",
    ".bundle-product-options-locks input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));
      var lock_handle = $(this).val();

      jQuery.getJSON(
        window.Shopify.routes.root + "products/" + lock_handle + ".js",
        function (product) {
          $(".current-lock").text(product.title);
          if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
            jQuery("#locks")
              .find(".about-bike-locks")
              .html(kitBuilderInfoDisc[product.id].dec);
          } else {
            jQuery("#locks").find(".about-bike-locks").html("");
          }

          var all_varients = product.variants;
          selected_locks_varient_details = all_varients[0];
          selected_locks_varient_details.handle = product.handle;

          var image_url = selected_locks_varient_details.featured_image.src;
          $(".kit-locks-image").remove();
          var image_class = "kit-product-image7";
          var locks_image =
            '<span style="width:20%" class="builder-bg-img kit-locks-image ' +
            image_class +
            '"><img class="kit-helmet" src="' +
            image_url +
            '"></span>';
          $(".kit-builder-img").append(locks_image);

          var itemPrice =
            check_strikethrough_price_for_locks(cart_bundle_cookie);
          $("#locks .lock-price").html(
            '<span class="money">' + itemPrice + "</strong></div></a></li>"
          );
          ValidateProductQtyForNextStep(
            selected_locks_varient_details.id,
            "locks"
          );
          hide_loader();
        }
      );
    }
  );

  //   get gloves tab html
  function get_product_info_glove(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_size_min = false;
          var is_style_min = false;
          option_index = i;
          if (o.name == "Style" || o.name == "style") {
            is_style_min = true;
          }
          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }

          var class_images = "";
          if (is_style_min) {
            class_images = "kb-kit-images";
          }

          bundle_html +=
            "<div class='bundle-product-options-gloves " +
            class_images +
            "' data-varients='" +
            JSON.stringify(JSON.stringify(product.variants)) +
            "'>";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          if (is_style_min) {
            bundle_html +=
              '<span class="swatch-title-bundle" " >Choose Your Gloves</span>';
          }

          bundle_html += '<div class="option_title">';
          bundle_html +=
            '<span class="swatch-type" data-name="' +
            o.name.toLowerCase() +
            '">' +
            o.name.toLowerCase() +
            "</span>";

          if (is_size_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-size-min"></span>';
          } else if (is_style_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-style-min"></span>';
          }

          if (is_style_min) {
            bundle_html +=
              '<span class="kit-builder-price gloves-price"> </span>';
          }

          bundle_html += "</div>";
          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);

                var soldClass =
                  kitBuilderInfo[v.id][inv_location] > 0
                    ? "available"
                    : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle + "-swatch";
                } else if (is_style_min) {
                  var element_class = "style " + handle + "-swatch";
                }

                bundle_html += '<div class = "swatch-min-item">';

                if (is_size_min) {
                  bundle_html +=
                    '<input id="option-' +
                    v.id +
                    '" type="radio" data-value="' +
                    v[op_index] +
                    '" data-product_id="' +
                    product.id +
                    '" data-id="' +
                    v.id +
                    '" data-is-color="' +
                    is_color_min +
                    '" data-variant-name="' +
                    v.title +
                    '" name="product-option-' +
                    option_index +
                    '" value="' +
                    v[op_index] +
                    '" ' +
                    checked +
                    ' class="' +
                    soldClass +
                    '" />';
                } else {
                  bundle_html +=
                    '<input id="option-' +
                    v.id +
                    '" type="radio" data-value="' +
                    v[op_index] +
                    '" data-product_id="' +
                    product.id +
                    '" data-id="' +
                    v.id +
                    '" data-is-color="' +
                    is_color_min +
                    '" data-variant-name="' +
                    v.title +
                    '" name="product-option-' +
                    option_index +
                    '" value="' +
                    v[op_index] +
                    '" ' +
                    checked +
                    ' class="' +
                    soldClass +
                    '" data-image="' +
                    imageUrl +
                    '" />';
                }

                bundle_html +=
                  '<div data-id="' +
                  v.id +
                  '" class="swatch-min-element available ' +
                  element_class +
                  '">';
                bundle_html += '<label for = "option-' + v.id + '">';

                if (is_style_min) {
                  bundle_html +=
                    '<img style="max-width:75px;" class="kit-ths-img" src="' +
                    v.featured_image.src +
                    '"/>';
                } else {
                  if (is_size_min) {
                    if (v[op_index] == "Small") {
                      bundle_html +=
                        '<span class="swatch-display-min"> S </span>';
                    } else if (v[op_index] == "Medium") {
                      bundle_html +=
                        '<span class="swatch-display-min"> M </span>';
                    } else if (v[op_index] == "Large") {
                      bundle_html +=
                        '<span class="swatch-display-min"> L </span>';
                    } else if (v[op_index] == "Extra Small") {
                      bundle_html +=
                        '<span class="swatch-display-min"> XS </span>';
                    } else if (v[op_index] == "Extra Large") {
                      bundle_html +=
                        '<span class="swatch-display-min"> XL </span>';
                    }
                  }
                  bundle_html +=
                    '<img class="crossed-out" src="' + assetsoldoutUrl + '"/>';
                }

                bundle_html += "</label>";
                bundle_html += "</div>";
                bundle_html += "</div>";
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        jQuery("#gloves")
          .find("." + handle)
          .html(bundle_html);
        jQuery("#gloves")
          .find(".see-fit-guide")
          .html(
            '<a href="javascript:void(0)" data-fancybox="fitguide" data-src="#size-guide-fit-glove" class="size_chart">See Fit Guide</a>'
          );
        // jQuery('[data-fancybox="fitguide"]').fancybox({
        //     beforeShow: function(){
        //       console.log('size chart trig');
        //         jQuery("body").addClass('blocked-scroll');
        //     },
        //     afterClose: function(){
        //         jQuery("body").removeClass('blocked-scroll');
        //     },
        //     touch: {
        //       vertical : false,
        //       momentum : false
        //     }
        //   });
        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery("#gloves")
            .find(".about-gloves")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery("#gloves").find(".about-gloves").html("");
        }

        let style = "";
        let size = "";
        jQuery("#gloves")
          .find(".bundle-product-options-gloves")
          .each(function (i, glovobj) {
            $(glovobj)
              .find(".clearfix")
              .find("input")
              .first()
              .prop("checked", true);
            let varient_name = $(glovobj)
              .find(".clearfix")
              .find("input")
              .first()
              .data("value");
            let type = $(glovobj)
              .find(".clearfix")
              .find(".option_title .swatch-type ")
              .text();

            if (
              $(glovobj).find(".clearfix").hasClass("swatch-type-min-style")
            ) {
              $(glovobj)
                .find(".clearfix")
                .find(".option_title .current-style-min")
                .text(varient_name);

              style = $(glovobj).find("input").first().val();
              $(glovobj).find("input").first().addClass("active");
            } else if (
              $(glovobj).find(".clearfix").hasClass("swatch-type-min-size")
            ) {
              $(glovobj)
                .find(".clearfix")
                .find(".option_title .current-size-min")
                .text(varient_name);
              size = $(glovobj).find("input").first().val();
            }
          });

        if (typeof cart_bundle_cookie.gloves != "undefined") {
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.gloves.style +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-1][value="' +
                cart_bundle_cookie.gloves.size +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.gloves.style +
                '"]'
            )
            .trigger("change");
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-1][value="' +
                cart_bundle_cookie.gloves.size +
                '"]'
            )
            .trigger("change");
        } else if (typeof edited_products.gloves != "undefined") {
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.gloves.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-1][value="' +
                edited_products.gloves.variant_options[1] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.gloves.variant_options[0] +
                '"]'
            )
            .trigger("change");
          $(".bundle-product-options-gloves")
            .find(
              'input[name=product-option-1][value="' +
                edited_products.gloves.variant_options[1] +
                '"]'
            )
            .trigger("change");
        } else {
          var all_varients = product.variants;
          var image_url = "";
          all_varients.forEach(function (item, index) {
            if (item.option1 == style && item.option2 == size) {
              selected_glove_varient_details = item;
              image_url = item.featured_image.src;
            }
            if (item.option1 == style) {
              if (kitBuilderInfo[item.id][inv_location] > 0) {
                $(".bundle-product-options-gloves")
                  .find(
                    'input[name=product-option-1][value="' + item.option2 + '"]'
                  )
                  .next()
                  .removeClass("soldout");
              } else {
                $(".bundle-product-options-gloves")
                  .find(
                    'input[name=product-option-1][value="' + item.option2 + '"]'
                  )
                  .next()
                  .addClass("soldout");
              }
            }
          });

          if (image_url != "" && typeof image_url != "undefined") {
            $(".kit-gloves-image").remove();
            var image_class = "kit-product-image3";
            var gloves_image =
              '<span class="builder-bg-img kit-gloves-image ' +
              image_class +
              '"><img class="kit-helmet" src="' +
              image_url +
              '"></span>';
            $(".kit-builder-img").append(gloves_image);
          }

          var itemPrice =
            check_strikethrough_price_for_gloves(cart_bundle_cookie);
          $("#gloves .gloves-price").html(
            '<span class="money">' + itemPrice + "</strong></div></a></li>"
          );
          ValidateProductQtyForNextStep(
            selected_glove_varient_details.id,
            "gloves"
          );
        }

        hide_loader();
      }
    );
  }

  function check_strikethrough_price_for_gloves(cart_bundle_cookie) {
    var itemPrice;
    var strikethrough_discount = false;
    if (mips_helmet || bike_helmet) {
      strikethrough_discount = true;
    } else if (typeof cart_bundle_cookie.helmet != "undefined") {
      strikethrough_discount = true;
    }
    var price = selected_glove_varient_details.price;
    var discount = false;
    if (
      strikethrough_discount &&
      strikethrough_discounted_price.little_courier_glove.dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      if (little_courier_glove.includes(selected_glove_varient_details.id)) {
        price = strikethrough_discounted_price.little_courier_glove.dis_price;
        discount = true;
      } else if (defrance_glove.includes(selected_glove_varient_details.id)) {
        price = strikethrough_discounted_price.defrance_glove.dis_price;
        discount = true;
      } else if (bullitt_glove.includes(selected_glove_varient_details.id)) {
        price = strikethrough_discounted_price.bullitt_glove.dis_price;
        discount = true;
      }
    }
    selected_glove_varient_details.bprice = price;
    var itemPrice = formatMoneyStripTrailingZeros(
      price,
      $("body").data("money-format")
    );
    if (discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(
          selected_glove_varient_details.price,
          $("body").data("money-format")
        ) +
        "</span>";
    }
    return itemPrice;
  }

  //  on glove variation change ..
  $(document).on(
    "change",
    ".bundle-product-options-gloves input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      $(".bundle-product-options-gloves input[type=radio]").removeClass(
        "active"
      );
      $(this).addClass("active");
      let image_url = $(this).data("image");
      var current_element = $(this);
      let varient_name = $(this).data("value");
      let type = $(this)
        .parents(".bundle-product-options-gloves")
        .find(".option_title .swatch-type")
        .data("name");

      if (type == "style" || type == "Style") {
        $(this)
          .parents(".bundle-product-options-gloves")
          .find(".option_title .current-style-min")
          .text(varient_name);
      } else if (type == "Size" || type == "size") {
        $(this)
          .parents(".bundle-product-options-gloves")
          .find(".option_title .current-size-min")
          .text(varient_name);
      }

      let varients = $(this)
        .parents(".bundle-product-options-gloves")
        .data("varients");
      if (isJson(varients)) {
        varients = JSON.parse(JSON.parse(varients));
      }

      let style = "";
      let size = "";
      var item_obj;

      $(current_element)
        .parents("#gloves")
        .find(".bundle-product-options-gloves")
        .each(function (i, glovobj) {
          if ($(glovobj).find(".clearfix").hasClass("swatch-type-min-style")) {
            style = $(glovobj)
              .find("input[name=product-option-0]:checked")
              .val();
          } else if (
            $(glovobj).find(".clearfix").hasClass("swatch-type-min-size")
          ) {
            size = $(glovobj)
              .find("input[name=product-option-1]:checked")
              .val();
          }
        });

      varients.forEach(function (item, index) {
        if (item.option1 == style && item.option2 == size) {
          selected_glove_varient_details = item;
        }
        if (item.option1 == style) {
          if (kitBuilderInfo[item.id][inv_location] > 0) {
            $(".bundle-product-options-gloves")
              .find(
                'input[name=product-option-1][value="' + item.option2 + '"]'
              )
              .next()
              .removeClass("soldout");
          } else {
            $(".bundle-product-options-gloves")
              .find(
                'input[name=product-option-1][value="' + item.option2 + '"]'
              )
              .next()
              .addClass("soldout");
          }
        }
      });

      if (image_url != "" && typeof image_url != "undefined") {
        $(".kit-gloves-image").remove();
        var image_class = "kit-product-image3";
        var gloves_image =
          '<span class="builder-bg-img kit-gloves-image ' +
          image_class +
          '"><img class="kit-helmet" src="' +
          image_url +
          '"></span>';
        $(".kit-builder-img").append(gloves_image);
      }

      var itemPrice = check_strikethrough_price_for_gloves(cart_bundle_cookie);
      $("#gloves .gloves-price").html(
        '<span class="money">' + itemPrice + "</strong></div></a></li>"
      );

      ValidateProductQtyForNextStep(
        selected_glove_varient_details.id,
        "gloves"
      );
    }
  );

  //   get bells , stickers tab html
  function get_products_bells_stickers(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));

    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_size_min = false;
          var is_style_min = false;
          option_index = i;
          if (o.name == "Style" || o.name == "style") {
            is_style_min = true;
          }
          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }
          if (
            o.name == "color" ||
            o.name == "Color" ||
            o.name == "colour" ||
            o.name == "Colour"
          ) {
            is_color_min = true;
          }

          var class_images = "";
          if (is_style_min || is_color_min) {
            class_images = "kb-kit-images";
          }

          var main_class = handle == "kids-stickers" ? "kids-stickers" : "";

          bundle_html +=
            "<div data-tab='" +
            current_tab +
            "' data-handle='" +
            handle +
            "' class='bundle-product-options-bs " +
            class_images +
            " " +
            main_class +
            "' >";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          if (handle == "kids-stickers") {
            bundle_html += '<div class="included-sticker-section">';
            bundle_html +=
              '<div class="option_title_already included-sticker-text">';
            bundle_html +=
              '<span class="swatch-type"> STICKER PACK COMES WITH PURCHASE </span>';
            bundle_html += "</div>";
            bundle_html +=
              '<div class="option_title_already included-visor-image">';
            bundle_html += '<div class="swatch-min-item">';
            bundle_html +=
              '<input id="option-39290080231471" type="radio" data-value="Thousand Jr." data-product_id="6549030502447" data-id="39290080231471" data-is-color="false" data-variant-name="Thousand Jr." name="product-option-0" value="Thousand Jr." class="available" data-image="https://cdn.shopify.com/s/files/1/0417/6701/0471/products/ThsdJR-sticker-ThousandJr-1_8ed44a81-b608-4553-a480-c3a70ecaa9f3.jpg?v=1647976187">';
            bundle_html +=
              '<div data-id="39290080231471" class="swatch-min-element available style thousand-jr-swatch">';
            bundle_html += '<label for="option-39290080231471">';
            bundle_html += '<label for="option-39290080231471">';
            bundle_html +=
              '<img class="crossed-out" src="' + assetsoldoutUrl + '">';
            bundle_html += "</label></div>";
            bundle_html += '<span class="swatch-type"> THOUSAND JR  </span>';
            bundle_html += "</div>";
            bundle_html += "</div>";
          }

          bundle_html += '<div class="option_title">';

          if (handle == "bike-bell" || handle == "kids-bell") {
            bundle_html +=
              '<span  data-name="' +
              o.name.toLowerCase() +
              '" class="swatch-type">Choose Your Bell</span>';
          } else if (handle == "helmet-stickers" || handle == "kids-stickers") {
            bundle_html +=
              '<span  data-name="' +
              o.name.toLowerCase() +
              '" class="swatch-type">Choose Your Sticker</span>';
          }

          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-color-min"></span>';
          } else if (is_size_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-size-min"></span>';
          } else if (is_style_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-style-min"></span>';
          }

          bundle_html +=
            '<span class="kit-builder-price bells-stickers-price"> </span>';

          bundle_html += "</div>";
          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle_v = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle_v + "-swatch";
                } else if (is_style_min) {
                  var element_class = "style " + handle_v + "-swatch";
                } else if (is_color_min) {
                  var element_class = "color " + handle_v + "-swatch";
                }

                if (handle_v != "thousand-jr") {
                  bundle_html += '<div class = "swatch-min-item">';
                  if (is_size_min) {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" />';
                  } else {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" data-image="' +
                      imageUrl +
                      '" />';
                  }

                  bundle_html +=
                    '<div data-id="' +
                    v.id +
                    '" class="swatch-min-element ' +
                    soldClass +
                    " " +
                    element_class +
                    '">';
                  bundle_html += '<label for = "option-' + v.id + '">';

                  if (handle == "kids-stickers") {
                    bundle_html +=
                      '<img class="crossed-out" src="' +
                      assetsoldoutUrl +
                      '"/>';
                  } else {
                    bundle_html +=
                      '<img style="max-width:75px;" class="kit-ths-img" src="' +
                      v.featured_image.src +
                      '"/>';
                  }

                  bundle_html += "</label>";
                  bundle_html += "</div>";
                  bundle_html += "</div>";
                }
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        if (handle == "kids-stickers") {
          bundle_html +=
            '<div class="kids-stickers-error" style="display:none">';
          bundle_html +=
            '<span class="kids-stickers-error-message">*This Sticker sheet is included with your helmet already</span>';
          bundle_html += "</div>";
        }

        var element_to_append = current_tab == "bells" ? "#bells" : "#stickers";
        var varient_id, sold_out;

        jQuery(element_to_append).find(".bells-stickers").html(bundle_html);

        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery(element_to_append)
            .find(".about-bells-stickers")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery(element_to_append).find(".about-bells-stickers").html("");
        }

        varient_id = jQuery(element_to_append)
          .find(".bundle-product-options-bs")
          .find("input")
          .first()
          .data("id");
        sold_out = jQuery(element_to_append)
          .find(".bundle-product-options-bs")
          .find("input")
          .first()
          .hasClass("soldout")
          ? true
          : false;

        let varient_name = jQuery(element_to_append)
          .find(".bundle-product-options-bs")
          .find("input")
          .first()
          .data("value");
        let type = jQuery(element_to_append)
          .find(".bundle-product-options-bs")
          .find(".option_title .swatch-type")
          .data("name");

        if (type == "Style" || type == "style") {
          jQuery(element_to_append)
            .find(".bundle-product-options-bs")
            .find(".option_title .current-style-min")
            .text(varient_name);
        } else if (type == "Color" || type == "color") {
          jQuery(element_to_append)
            .find(".bundle-product-options-bs")
            .find(".option_title .current-color-min")
            .text(varient_name);
        } else if (type == "Size" || type == "size") {
          jQuery(element_to_append)
            .find(".bundle-product-options-bs")
            .find(".option_title .current-size-min")
            .text(varient_name);
        }

        jQuery(element_to_append)
          .find(".bundle-product-options-bs")
          .find("input")
          .first()
          .prop("checked", true);

        var price = 0;
        var image_url = "";
        selected_bells_sticker_variation = product.variants;

        selected_bells_sticker_variation.forEach(function (item, index) {
          if (item.id == varient_id) {
            if (current_tab == "bells") {
              selected_bells_varient_details = item;
              selected_bells_varient_handle = handle;
            } else {
              selected_sticker_varient_details = item;
              selected_sticker_varient_handle = handle;
            }
            price = item.price;
            image_url = item.featured_image.src;
          }
        });

        if (current_tab == "bells") {
          if (typeof cart_bundle_cookie.bells != "undefined") {
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  cart_bundle_cookie.bells.option +
                  '"]'
              )
              .prop("checked", true);
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  cart_bundle_cookie.bells.option +
                  '"]'
              )
              .trigger("change");
          } else if (typeof edited_products.bells != "undefined") {
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  edited_products.bells.variant_options[0] +
                  '"]'
              )
              .prop("checked", true);
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  edited_products.bells.variant_options[0] +
                  '"]'
              )
              .trigger("change");
          } else {
            $(".kit-bells-image").remove();

            var image_class = "kit-product-image4";
            var bells_image =
              '<span class="builder-bg-img kit-bells-image ' +
              image_class +
              '"><img class="kit-helmet" src="' +
              image_url +
              '"></span>';
            $(".kit-builder-img").append(bells_image);

            var itemPrice = check_bells_strickers_strikethrough_price(
              cart_bundle_cookie,
              handle,
              current_tab,
              price
            );

            $(element_to_append)
              .find(".bells-stickers-price")
              .html(
                '<span class="money">' + itemPrice + "</strong></div></a></li>"
              );

            ValidateProductQtyForNextStep(
              selected_bells_varient_details.id,
              "bells"
            );
          }
        } else if (current_tab == "stickers") {
          if (typeof cart_bundle_cookie.stickers != "undefined") {
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  cart_bundle_cookie.stickers.option +
                  '"]'
              )
              .prop("checked", true);
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  cart_bundle_cookie.stickers.option +
                  '"]'
              )
              .trigger("change");
          } else if (typeof edited_products.stickers != "undefined") {
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  edited_products.stickers.variant_options[0] +
                  '"]'
              )
              .prop("checked", true);
            $(".bundle-product-options-bs")
              .find(
                'input[name=product-option-0][value="' +
                  edited_products.stickers.variant_options[0] +
                  '"]'
              )
              .trigger("change");
          } else {
            $(".kit-stickers-image").remove();
            var image_class = "kit-product-image5";
            var stickers_image =
              '<span class="builder-bg-img kit-stickers-image ' +
              image_class +
              '"><img class="kit-helmet" src="' +
              image_url +
              '"></span>';
            $(".kit-builder-img").append(stickers_image);

            var itemPrice = check_bells_strickers_strikethrough_price(
              cart_bundle_cookie,
              handle,
              current_tab,
              price
            );

            $(element_to_append)
              .find(".bells-stickers-price")
              .html(
                '<span class="money">' + itemPrice + "</strong></div></a></li>"
              );

            ValidateProductQtyForNextStep(
              selected_sticker_varient_details.id,
              "sticker"
            );

            if (varient_name == "Thousand Jr.") {
              $(".kids-stickers-error").show();
            } else {
              $(".kids-stickers-error").hide();
            }
          }
        }
        hide_loader();
      }
    );
  }

  function check_bells_strickers_strikethrough_price(
    cart_bundle_cookie,
    handle,
    current_tab,
    price
  ) {
    var strikethrough_discount = false;
    var dis_price = price;

    if (current_tab == "bells") {
      if (
        strikethrough_discounted_price.kids_bell.dis_price != "" &&
        strikethrough_visibility_rideshop == "true"
      ) {
        if (handle == "kids-bell") {
          if (kids_helmet) {
            strikethrough_discount = true;
            dis_price = strikethrough_discounted_price.kids_bell.dis_price;
          } else if (typeof cart_bundle_cookie.helmet != "undefined") {
            strikethrough_discount = true;
            dis_price = strikethrough_discounted_price.kids_bell.dis_price;
          }
        } else if (handle == "bike-bell") {
          if (mips_helmet || bike_helmet) {
            strikethrough_discount = true;
            dis_price = strikethrough_discounted_price.bike_bell.dis_price;
          } else if (typeof cart_bundle_cookie.helmet != "undefined") {
            strikethrough_discount = true;
            dis_price = strikethrough_discounted_price.bike_bell.dis_price;
          }
        }
      }

      selected_bells_varient_details.bprice = dis_price;
    } else if (current_tab == "stickers") {
      if (
        strikethrough_discounted_price.helmet_stickers.dis_price != "" &&
        strikethrough_visibility_rideshop == "true"
      ) {
        if (handle == "helmet-stickers") {
          if (bike_helmet) {
            strikethrough_discount = true;
            dis_price =
              strikethrough_discounted_price.helmet_stickers.dis_price;
          } else if (
            typeof cart_bundle_cookie.helmet != "undefined" &&
            cart_bundle_cookie.helmet.helmet_type == "bike-helmet"
          ) {
            strikethrough_discount = true;
            dis_price =
              strikethrough_discounted_price.helmet_stickers.dis_price;
          }
        } else if (handle == "kids-stickers") {
          if (kids_helmet) {
            strikethrough_discount = true;
            dis_price = strikethrough_discounted_price.kids_stickers.dis_price;
          } else if (typeof cart_bundle_cookie.helmet != "undefined") {
            strikethrough_discount = true;
            dis_price = strikethrough_discounted_price.kids_stickers.dis_price;
          }
        }
      }
      selected_sticker_varient_details.bprice = dis_price;
    }

    var itemPrice = formatMoneyStripTrailingZeros(
      dis_price,
      $("body").data("money-format")
    );
    if (strikethrough_discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(price, $("body").data("money-format")) +
        "</span>";
    }

    return itemPrice;
  }

  //   on bells-stickers variation change
  $(document).on(
    "change",
    ".bundle-product-options-bs input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      var current_element = $(this);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      var handle = $(this).parents(".bundle-product-options-bs").data("handle");
      var tab = $(this).parents(".bundle-product-options-bs").data("tab");
      let image_url = $(this).data("image");
      let varient_name = $(this).data("value");

      if (varient_name == "Thousand Jr.") {
        $(".kids-stickers-error").show();
      } else {
        $(".kids-stickers-error").hide();
      }

      let type = $(this)
        .parents(".bundle-product-options-bs")
        .find(".option_title .swatch-type")
        .data("name");

      if (type == "style" || type == "Style") {
        $(this)
          .parents(".bundle-product-options-bs")
          .find(".option_title .current-style-min")
          .text(varient_name);
      } else if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options-bs")
          .find(".option_title .current-color-min")
          .text(varient_name);
      } else if (type == "Size" || type == "size") {
        $(this)
          .parents(".bundle-product-options-bs")
          .find(".option_title .current-size-min")
          .text(varient_name);
      }

      let varient_id = "";
      let sold_out = false;

      varient_id = $(this).data("id");
      sold_out = $(this).hasClass("soldout") ? true : false;

      var price = 0;
      selected_bells_sticker_variation.forEach(function (item, index) {
        if (item.id == varient_id) {
          if (current_tab == "bells") {
            selected_bells_varient_details = item;
            selected_bells_varient_handle = handle;
          } else {
            selected_sticker_varient_details = item;
            selected_sticker_varient_handle = handle;
          }
          price = item.price;
        }
      });

      if (image_url != "" && typeof image_url != "undefined") {
        if (current_tab == "bells") {
          $(".kit-bells-image").remove();
          var image_class = "kit-product-image4";
          var bells_image =
            '<span class="builder-bg-img kit-bells-image ' +
            image_class +
            '"><img class="kit-helmet" src="' +
            image_url +
            '"></span>';
          $(".kit-builder-img").append(bells_image);
        } else {
          $(".kit-stickers-image").remove();
          var image_class = "kit-product-image5";
          var stickers_image =
            '<span class="builder-bg-img kit-stickers-image ' +
            image_class +
            '"><img class="kit-helmet" src="' +
            image_url +
            '"></span>';
          $(".kit-builder-img").append(stickers_image);
        }
      }

      var itemPrice = check_bells_strickers_strikethrough_price(
        cart_bundle_cookie,
        handle,
        current_tab,
        price
      );

      $("#" + tab)
        .find(".bells-stickers-price")
        .html('<span class="money">' + itemPrice + "</strong></div></a></li>");
      if (current_tab == "bells") {
        ValidateProductQtyForNextStep(
          selected_bells_varient_details.id,
          "bells"
        );
      } else if (current_tab == "stickers") {
        ValidateProductQtyForNextStep(
          selected_sticker_varient_details.id,
          "sticker"
        );
      }
    }
  );

  //   get socks tab html
  function get_products_socks(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));

    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_size_min = false;
          var is_style_min = false;
          option_index = i;
          if (o.name == "Style" || o.name == "style") {
            is_style_min = true;
          }
          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }
          if (
            o.name == "color" ||
            o.name == "Color" ||
            o.name == "colour" ||
            o.name == "Colour"
          ) {
            is_color_min = true;
           
          }

          var class_images = "";
          if (is_style_min || is_color_min) {
            class_images = "kb-kit-images";
          }

          var main_class = "socks-main";

          bundle_html +=
            "<div data-tab='" +
            current_tab +
            "' data-handle='" +
            handle +
            "' class='bundle-product-options-socks " +
            class_images +
            " " +
            main_class +
            "' >";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          bundle_html += '<div class="option_title">';

          if (handle == "remix-socks") {
            bundle_html +=
              '<span  data-name="' +
              o.name.toLowerCase() +
              '" class="swatch-type">Choose Your Size</span>';
          }

          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-color-min">Small/Medium</span>';
          } else if (is_size_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-size-min">Small/Medium</span>';
          } else if (is_style_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-style-min">Small/Medium</span>';
          }

          bundle_html += '<span class="kit-builder-price socks-price"> </span>';

          bundle_html += "</div>";
          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle_v = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle_v + "-swatch";
                } else if (is_style_min) {
                  var element_class = "style " + handle_v + "-swatch";
                } else if (is_color_min) {
                  var element_class = "color " + handle_v + "-swatch";
                }

                if (handle_v != "thousand-jr") {
                  bundle_html += '<div class = "swatch-min-item">';
                  if (is_size_min) {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" />';
                  } else {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" data-image="' +
                      imageUrl +
                      '" />';
                  }

                  bundle_html +=
                    '<div data-id="' +
                    v.id +
                    '" class="swatch-min-element ' +
                    soldClass +
                    " " +
                    element_class +
                    '">';
                  bundle_html += '<label for = "option-' + v.id + '">';

                  bundle_html +=
                    '<img style="max-width:75px;" class="kit-ths-img" src="' +
                    v.featured_image.src +
                    '"/>';
                  bundle_html += '<span class="socks-size-img">' + v[op_index].replace('Small','S').replace('Medium','M').replace('Large','L') + '</span>';

                  bundle_html += "</label>";
                  bundle_html += "</div>";
                  bundle_html += "</div>";
                }
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });       
        var element_to_append = "#socks";
        var varient_id, sold_out;

        jQuery(element_to_append).find(".socks").html(bundle_html);
        
        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery(element_to_append)
            .find(".about-socks")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery(element_to_append).find(".about-socks").html("");
        }

        varient_id = jQuery(element_to_append)
          .find(".bundle-product-options-socks")
          .find("input")
          .first()
          .data("id");
        sold_out = jQuery(element_to_append)
          .find(".bundle-product-options-socks")
          .find("input")
          .first()
          .hasClass("soldout")
          ? true
          : false;

        let varient_name = jQuery(element_to_append)
          .find(".bundle-product-options-socks")
          .find("input")
          .first()
          .data("value");
        let type = jQuery(element_to_append)
          .find(".bundle-product-options-socks")
          .find(".option_title .swatch-type")
          .data("name");

        if (type == "Style" || type == "style") {
          jQuery(element_to_append)
            .find(".bundle-product-options-socks")
            .find(".option_title .current-style-min")
            .text(varient_name);
          } else if (type == "Color" || type == "color") {
            jQuery(element_to_append)
              .find(".bundle-product-options-socks")
              .find(".option_title .current-color-min")
              .text(varient_name);
        } else if (type == "Size" || type == "size") {
          jQuery(element_to_append)
            .find(".bundle-product-options-socks")
            .find(".option_title .current-size-min")
            .text(varient_name);
        }

        jQuery(element_to_append)
          .find(".bundle-product-options-socks")
          .find("input")
          .first()
          .prop("checked", true);

        var price = 0;
        var image_url = "";
        selected_socks_variation = product.variants;

        selected_socks_variation.forEach(function (item, index) {
          if (item.id == varient_id) {
            selected_socks_varient_details = item;
            selected_socks_varient_handle = handle;
            price = item.price;
            image_url = item.featured_image.src;
          }
        });

        if (typeof cart_bundle_cookie.socks != "undefined") {
          $(".bundle-product-options-socks")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.socks.option +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-socks")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.socks.option +
                '"]'
            )
            .trigger("change");
        } else if (typeof edited_products.socks != "undefined") {
          $(".bundle-product-options-socks")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.socks.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-socks")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.socks.variant_options[0] +
                '"]'
            )
            .trigger("change");
        } else {
          $(".kit-socks-image").remove();

          var image_class = "kit-product-image4";
          var socks_image =
            '<span class="builder-bg-img kit-socks-image ' +
            image_class +
            '"><img class="kit-helmet" src="' +
            image_url +
            '"></span>';
          $(".kit-builder-img").append(socks_image);

          var itemPrice = check_socks_strikethrough_price(
            cart_bundle_cookie,
            handle,
            current_tab,
            price
          );

          $(element_to_append)
            .find(".socks-price")
            .html(
              '<span class="money">' + itemPrice + "</strong></div></a></li>"
            );

          ValidateProductQtyForNextStep(
            selected_socks_varient_details.id,
            "socks"
          );
        }

        hide_loader();
      }
    );
  }

  function check_socks_strikethrough_price(
    cart_bundle_cookie,
    handle,
    current_tab,
    price
  ) {
    var strikethrough_discount = false;
    var dis_price = price;

    if (
      strikethrough_discounted_price.socks.dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      if (mips_helmet || bike_helmet) {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.socks.dis_price;
      } else if (typeof cart_bundle_cookie.helmet != "undefined") {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.socks.dis_price;
      }
    }

    selected_socks_varient_details.bprice = dis_price;

    var itemPrice = formatMoneyStripTrailingZeros(
      dis_price,
      $("body").data("money-format")
    );
    if (strikethrough_discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(price, $("body").data("money-format")) +
        "</span>";
    }

    return itemPrice;
  }

  //   on socks- variation change
  $(document).on(
    "change",
    ".bundle-product-options-socks input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      var current_element = $(this);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      var handle = $(this)
        .parents(".bundle-product-options-socks")
        .data("handle");
      var tab = $(this).parents(".bundle-product-options-socks").data("tab");
      let image_url = $(this).data("image");
      let varient_name = $(this).data("value");

      let type = $(this)
        .parents(".bundle-product-options-socks")
        .find(".option_title .swatch-type")
        .data("name");

      if (type == "style" || type == "Style") {
        $(this)
          .parents(".bundle-product-options-socks")
          .find(".option_title .current-style-min")
          .text(varient_name);
      } else if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options-socks")
          .find(".option_title .current-color-min")
          .text(varient_name);
      } else if (type == "Size" || type == "size") {
        $(this)
          .parents(".bundle-product-options-socks")
          .find(".option_title .current-size-min")
          .text(varient_name);
      }

      let varient_id = "";
      let sold_out = false;

      varient_id = $(this).data("id");
      sold_out = $(this).hasClass("soldout") ? true : false;

      var price = 0;
      selected_socks_variation.forEach(function (item, index) {
        if (item.id == varient_id) {
          selected_socks_varient_details = item;
          selected_socks_varient_handle = handle;
          price = item.price;
        }
      });

      if (image_url != "" && typeof image_url != "undefined") {
        $(".kit-socks-image").remove();
        var image_class = "kit-product-image4";
        var socks_image =
          '<span class="builder-bg-img kit-socks-image ' +
          image_class +
          '"><img class="kit-helmet" src="' +
          image_url +
          '"></span>';
        $(".kit-builder-img").append(socks_image);
      }

      var itemPrice = check_socks_strikethrough_price(
        cart_bundle_cookie,
        handle,
        current_tab,
        price
      );

      $("#" + tab)
        .find(".socks-price")
        .html('<span class="money">' + itemPrice + "</strong></div></a></li>");

      ValidateProductQtyForNextStep(selected_socks_varient_details.id, "socks");
    }
  );

  //   get gaiter tab html
  function get_products_gaiter(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));

    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_size_min = false;
          var is_style_min = false;
          option_index = i;
          if (o.name == "Style" || o.name == "style") {
            is_style_min = true;
          }
          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }
          if (
            o.name == "color" ||
            o.name == "Color" ||
            o.name == "colour" ||
            o.name == "Colour"
          ) {
            is_color_min = true;
          }

          var class_images = "";
          if (is_style_min || is_color_min) {
            class_images = "kb-kit-images";
          }

          var main_class = "gaiter-main";

          bundle_html +=
            "<div data-tab='" +
            current_tab +
            "' data-handle='" +
            handle +
            "' class='bundle-product-options-gaiter " +
            class_images +
            " " +
            main_class +
            "' >";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          bundle_html += '<div class="option_title">';

          if (handle == "remix-gaiter") {
            bundle_html +=
              '<span  data-name="' +
              o.name.toLowerCase() +
              '" class="swatch-type">One Size</span>';
          }

          

          bundle_html +=
            '<span class="kit-builder-price gaiter-price"> </span>';

          bundle_html += "</div>";
          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle_v = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle_v + "-swatch";
                } else if (is_style_min) {
                  var element_class = "style " + handle_v + "-swatch";
                } else if (is_color_min) {
                  var element_class = "color " + handle_v + "-swatch";
                }

                if (handle_v != "thousand-jr") {
                  bundle_html += '<div class = "swatch-min-item">';
                  if (is_size_min) {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" />';
                  } else {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" data-image="' +
                      imageUrl +
                      '" />';
                  }

                  bundle_html +=
                    '<div data-id="' +
                    v.id +
                    '" class="swatch-min-element ' +
                    soldClass +
                    " " +
                    element_class +
                    '">';
                  bundle_html += '<label for = "option-' + v.id + '">';

                  bundle_html +=
                    '<img style="max-width:75px;" class="kit-ths-img" src="' +
                    v.featured_image.src +
                    '"/>';

                  bundle_html += "</label>";
                  bundle_html += "</div>";
                  bundle_html += "</div>";
                }
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        var element_to_append = "#gaiter";
        var varient_id, sold_out;

        jQuery(element_to_append).find(".gaiter").html(bundle_html);

        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery(element_to_append)
            .find(".about-gaiter")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery(element_to_append).find(".about-gaiter").html("");
        }

        varient_id = jQuery(element_to_append)
          .find(".bundle-product-options-gaiter")
          .find("input")
          .first()
          .data("id");
        sold_out = jQuery(element_to_append)
          .find(".bundle-product-options-gaiter")
          .find("input")
          .first()
          .hasClass("soldout")
          ? true
          : false;

        let varient_name = jQuery(element_to_append)
          .find(".bundle-product-options-gaiter")
          .find("input")
          .first()
          .data("value");
        let type = jQuery(element_to_append)
          .find(".bundle-product-options-gaiter")
          .find(".option_title .swatch-type")
          .data("name");

        if (type == "Style" || type == "style") {
          jQuery(element_to_append)
            .find(".bundle-product-options-gaiter")
            .find(".option_title .current-style-min")
            .text(varient_name);
          // } else if (type == "Color" || type == "color") {
          //   jQuery(element_to_append)
          //     .find(".bundle-product-options-gaiter")
          //     .find(".option_title .current-color-min")
          //     .text(varient_name);
        } else if (type == "Size" || type == "size") {
          jQuery(element_to_append)
            .find(".bundle-product-options-gaiter")
            .find(".option_title .current-size-min")
            .text(varient_name);
        }

        jQuery(element_to_append)
          .find(".bundle-product-options-gaiter")
          .find("input")
          .first()
          .prop("checked", true);

        var price = 0;
        var image_url = "";
        selected_gaiter_variation = product.variants;

        selected_gaiter_variation.forEach(function (item, index) {
          if (item.id == varient_id) {
            selected_gaiter_varient_details = item;
            selected_gaiter_varient_handle = handle;
            price = item.price;
            image_url = item.featured_image.src;
          }
        });

        if (typeof cart_bundle_cookie.gaiter != "undefined") {
          $(".bundle-product-options-gaiter")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.gaiter.option +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-gaiter")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.gaiter.option +
                '"]'
            )
            .trigger("change");
        } else if (typeof edited_products.gaiter != "undefined") {
          $(".bundle-product-options-gaiter")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.gaiter.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-gaiter")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.gaiter.variant_options[0] +
                '"]'
            )
            .trigger("change");
        } else {
          $(".kit-gaiter-image").remove();

          var image_class = "kit-product-image4";
          var gaiter_image =
            '<span class="builder-bg-img kit-gaiter-image ' +
            image_class +
            '"><img class="kit-helmet" src="' +
            image_url +
            '"></span>';
          $(".kit-builder-img").append(gaiter_image);

          var itemPrice = check_gaiter_strikethrough_price(
            cart_bundle_cookie,
            handle,
            current_tab,
            price
          );

          $(element_to_append)
            .find(".gaiter-price")
            .html(
              '<span class="money">' + itemPrice + "</strong></div></a></li>"
            );

          ValidateProductQtyForNextStep(
            selected_gaiter_varient_details.id,
            "gaiter"
          );
        }

        hide_loader();
      }
    );
  }

  function check_gaiter_strikethrough_price(
    cart_bundle_cookie,
    handle,
    current_tab,
    price
  ) {
    var strikethrough_discount = false;
    var dis_price = price;

    if (
      strikethrough_discounted_price.gaiter.dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      if (mips_helmet || bike_helmet) {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.gaiter.dis_price;
      } else if (typeof cart_bundle_cookie.helmet != "undefined") {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.gaiter.dis_price;
      }
    }

    selected_gaiter_varient_details.bprice = dis_price;

    var itemPrice = formatMoneyStripTrailingZeros(
      dis_price,
      $("body").data("money-format")
    );
    if (strikethrough_discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(price, $("body").data("money-format")) +
        "</span>";
    }

    return itemPrice;
  }

  //   on gaiter- variation change
  $(document).on(
    "change",
    ".bundle-product-options-gaiter input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      var current_element = $(this);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      var handle = $(this)
        .parents(".bundle-product-options-gaiter")
        .data("handle");
      var tab = $(this).parents(".bundle-product-options-gaiter").data("tab");
      let image_url = $(this).data("image");
      let varient_name = $(this).data("value");

      let type = $(this)
        .parents(".bundle-product-options-gaiter")
        .find(".option_title .swatch-type")
        .data("name");

      if (type == "style" || type == "Style") {
        $(this)
          .parents(".bundle-product-options-gaiter")
          .find(".option_title .current-style-min")
          .text(varient_name);
      } else if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options-gaiter")
          .find(".option_title .current-color-min")
          .text(varient_name);
      } else if (type == "Size" || type == "size") {
        $(this)
          .parents(".bundle-product-options-gaiter")
          .find(".option_title .current-size-min")
          .text(varient_name);
      }

      let varient_id = "";
      let sold_out = false;

      varient_id = $(this).data("id");
      sold_out = $(this).hasClass("soldout") ? true : false;

      var price = 0;
      selected_gaiter_variation.forEach(function (item, index) {
        if (item.id == varient_id) {
          selected_gaiter_varient_details = item;
          selected_gaiter_varient_handle = handle;
          price = item.price;
        }
      });

      if (image_url != "" && typeof image_url != "undefined") {
        $(".kit-gaiter-image").remove();
        var image_class = "kit-product-image4";
        var gaiter_image =
          '<span class="builder-bg-img kit-gaiter-image ' +
          image_class +
          '"><img class="kit-helmet" src="' +
          image_url +
          '"></span>';
        $(".kit-builder-img").append(gaiter_image);
      }

      var itemPrice = check_gaiter_strikethrough_price(
        cart_bundle_cookie,
        handle,
        current_tab,
        price
      );

      $("#" + tab)
        .find(".gaiter-price")
        .html('<span class="money">' + itemPrice + "</strong></div></a></li>");

      ValidateProductQtyForNextStep(
        selected_gaiter_varient_details.id,
        "gaiter"
      );
    }
  );

    //   get remixgloves tab html
  function get_products_remixgloves(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));

    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        var option_index = 0;
        $.each(product.options, function (i, o) {          
          var is_color_min = false;
          var is_size_min = false;
          var is_style_min = false;
          option_index = i;
          if (o.name == "Style" || o.name == "style") {
            is_style_min = true;
          }
          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }
          if (
            o.name == "color" ||
            o.name == "Color" ||
            o.name == "colour" ||
            o.name == "Colour"
          ) {
            is_color_min = true;
           
          }

          var class_images = "";
          if (is_style_min || is_color_min) {
            class_images = "kb-kit-images";
          }

          var main_class = "remixgloves-main";

          bundle_html +=
            "<div data-tab='" +
            current_tab +
            "' data-handle='" +
            handle +
            "' class='bundle-product-options-remixgloves " +
            class_images +
            " " +
            main_class +
            "' >";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          bundle_html += '<div class="option_title">';
          if (handle == "remix-gloves") {
            bundle_html +=
              '<span  data-name="' +
              o.name.toLowerCase() +
              '" class="swatch-type">Choose Your Size</span>';
          }

          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-color-min">Extra Small</span>';
          } else if (is_size_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-size-min">Extra Small</span>';
          } else if (is_style_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-style-min">Extra Small</span>';
          }

          bundle_html += '<span class="kit-builder-price remixgloves-price"> </span>';

          bundle_html += "</div>";
          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle_v = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle_v + "-swatch";
                } else if (is_style_min) {
                  var element_class = "style " + handle_v + "-swatch";
                } else if (is_color_min) {
                  var element_class = "color " + handle_v + "-swatch";
                }

                if (handle_v != "thousand-jr") {
                  bundle_html += '<div class = "swatch-min-item">';
                  if (is_size_min) {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" />';
                  } else {
                    bundle_html +=
                      '<input id="option-' +
                      v.id +
                      '" type="radio" data-value="' +
                      v[op_index] +
                      '" data-product_id="' +
                      product.id +
                      '" data-id="' +
                      v.id +
                      '" data-is-color="' +
                      is_color_min +
                      '" data-variant-name="' +
                      v.title +
                      '" name="product-option-' +
                      option_index +
                      '" value="' +
                      v[op_index] +
                      '" ' +
                      checked +
                      ' class="' +
                      soldClass +
                      '" data-image="' +
                      imageUrl +
                      '" />';
                  }

                  bundle_html +=
                    '<div data-id="' +
                    v.id +
                    '" class="swatch-min-element ' +
                    soldClass +
                    " " +
                    element_class +
                    '">';
                  bundle_html += '<label for = "option-' + v.id + '">';

                  bundle_html +=
                    '<img style="max-width:75px;" class="kit-ths-img" src="' +
                    v.featured_image.src +
                    '"/>';
                  bundle_html += '<span class="remixgloves-size-img">' + v[op_index].replace('Extra Small','XS').replace('Extra Large','XL').replace('Small','S').replace('Medium','M').replace('Large','L') + '</span>';

                  bundle_html += "</label>";
                  bundle_html += "</div>";
                  bundle_html += "</div>";
                }
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        var element_to_append = "#remixgloves";
        var varient_id, sold_out;

        jQuery(element_to_append).find(".remixgloves").html(bundle_html);

        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery(element_to_append)
            .find(".about-remixgloves")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery(element_to_append).find(".about-remixgloves").html("");
        }

        varient_id = jQuery(element_to_append)
          .find(".bundle-product-options-remixgloves")
          .find("input")
          .first()
          .data("id");
        sold_out = jQuery(element_to_append)
          .find(".bundle-product-options-remixgloves")
          .find("input")
          .first()
          .hasClass("soldout")
          ? true
          : false;

        let varient_name = jQuery(element_to_append)
          .find(".bundle-product-options-remixgloves")
          .find("input")
          .first()
          .data("value");
        let type = jQuery(element_to_append)
          .find(".bundle-product-options-remixgloves")
          .find(".option_title .swatch-type")
          .data("name");

        if (type == "Style" || type == "style") {
          jQuery(element_to_append)
            .find(".bundle-product-options-remixgloves")
            .find(".option_title .current-style-min")
            .text(varient_name);
          // } else if (type == "Color" || type == "color") {
          //   jQuery(element_to_append)
          //     .find(".bundle-product-options-remixgloves")
          //     .find(".option_title .current-color-min")
          //     .text(varient_name);
        } else if (type == "Size" || type == "size") {
          jQuery(element_to_append)
            .find(".bundle-product-options-remixgloves")
            .find(".option_title .current-size-min")
            .text(varient_name);
        }

        jQuery(element_to_append)
          .find(".bundle-product-options-remixgloves")
          .find("input")
          .first()
          .prop("checked", true);

        var price = 0;
        var image_url = "";
        selected_remixgloves_variation = product.variants;

        selected_remixgloves_variation.forEach(function (item, index) {
          if (item.id == varient_id) {
            selected_remixgloves_varient_details = item;
            selected_remixgloves_varient_handle = handle;
            price = item.price;
            image_url = item.featured_image.src;
          }
        });

        if (typeof cart_bundle_cookie.remixgloves != "undefined") {
          $(".bundle-product-options-remixgloves")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.remixgloves.option +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-remixgloves")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.remixgloves.option +
                '"]'
            )
            .trigger("change");
        } else if (typeof edited_products.remixgloves != "undefined") {
          $(".bundle-product-options-remixgloves")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.remixgloves.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-remixgloves")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.remixgloves.variant_options[0] +
                '"]'
            )
            .trigger("change");
        } else {
          $(".kit-remixgloves-image").remove();

          var image_class = "kit-product-image4";
          var remixgloves_image =
            '<span class="builder-bg-img kit-remixgloves-image ' +
            image_class +
            '"><img class="kit-helmet" src="' +
            image_url +
            '"></span>';
          $(".kit-builder-img").append(remixgloves_image);

          var itemPrice = check_remixgloves_strikethrough_price(
            cart_bundle_cookie,
            handle,
            current_tab,
            price
          );

          $(element_to_append)
            .find(".remixgloves-price")
            .html(
              '<span class="money">' + itemPrice + "</strong></div></a></li>"
            );

          ValidateProductQtyForNextStep(
            selected_remixgloves_varient_details.id,
            "remixgloves"
          );
        }

        hide_loader();
      }
    );
  }

  function check_remixgloves_strikethrough_price(
    cart_bundle_cookie,
    handle,
    current_tab,
    price
  ) {
    var strikethrough_discount = false;
    var dis_price = price;

    if (
      strikethrough_discounted_price.remixgloves.dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      if (mips_helmet || bike_helmet) {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.remixgloves.dis_price;
      } else if (typeof cart_bundle_cookie.helmet != "undefined") {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.remixgloves.dis_price;
      }
    }

    selected_remixgloves_varient_details.bprice = dis_price;

    var itemPrice = formatMoneyStripTrailingZeros(
      dis_price,
      $("body").data("money-format")
    );
    if (strikethrough_discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(price, $("body").data("money-format")) +
        "</span>";
    }

    return itemPrice;
  }

  //   on remixgloves- variation change
  $(document).on(
    "change",
    ".bundle-product-options-remixgloves input[type=radio]",
    function () {      
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
      var current_element = $(this);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      var handle = $(this)
        .parents(".bundle-product-options-remixgloves")
        .data("handle");
      var tab = $(this).parents(".bundle-product-options-remixgloves").data("tab");
      let image_url = $(this).data("image");
      let varient_name = $(this).data("value");

      let type = $(this)
        .parents(".bundle-product-options-remixgloves")
        .find(".option_title .swatch-type")
        .data("name");

      if (type == "style" || type == "Style") {
        $(this)
          .parents(".bundle-product-options-remixgloves")
          .find(".option_title .current-style-min")
          .text(varient_name);
      } else if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options-remixgloves")
          .find(".option_title .current-color-min")
          .text(varient_name);
      } else if (type == "Size" || type == "size") {
        $(this)
          .parents(".bundle-product-options-remixgloves")
          .find(".option_title .current-size-min")
          .text(varient_name);
      }

      let varient_id = "";
      let sold_out = false;

      varient_id = $(this).data("id");
      sold_out = $(this).hasClass("soldout") ? true : false;

      var price = 0;
      selected_remixgloves_variation.forEach(function (item, index) {
        if (item.id == varient_id) {
          selected_remixgloves_varient_details = item;
          selected_remixgloves_varient_handle = handle;
          price = item.price;
        }
      });

      if (image_url != "" && typeof image_url != "undefined") {
        $(".kit-remixgloves-image").remove();
        var image_class = "kit-product-image4";
        var remixgloves_image =
          '<span class="builder-bg-img kit-remixgloves-image ' +
          image_class +
          '"><img class="kit-helmet" src="' +
          image_url +
          '"></span>';
        $(".kit-builder-img").append(remixgloves_image);
      }

      var itemPrice = check_remixgloves_strikethrough_price(
        cart_bundle_cookie,
        handle,
        current_tab,
        price
      );

      $("#" + tab)
        .find(".remixgloves-price")
        .html('<span class="money">' + itemPrice + "</strong></div></a></li>");

      ValidateProductQtyForNextStep(selected_remixgloves_varient_details.id, "remixgloves");
    }
  );

  // get visor tab html
  function get_products_visor(handle) {
    $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    var bundle_html = "";
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        visor_all_images = product.media;

        var already_added_visor_name =
          already_added_visor[selected_helmet_varient_color]["name"];
        already_added_visor_details = get_already_added_visor_details(
          product.variants,
          already_added_visor_name
        );

        var option_index = 0;
        $.each(product.options, function (i, o) {
          var is_color_min = false;
          var is_size_min = false;
          var is_style_min = false;
          option_index = i;
          if (o.name == "Style" || o.name == "style") {
            is_style_min = true;
          }
          if (o.name == "Size" || o.name == "size") {
            is_size_min = true;
          }
          if (
            o.name == "color" ||
            o.name == "Color" ||
            o.name == "colour" ||
            o.name == "Colour"
          ) {
            is_color_min = true;
          }

          bundle_html +=
            "<div data-tab='" +
            current_tab +
            "' class='bundle-product-options-visor' data-varients='" +
            JSON.stringify(JSON.stringify(product.variants)) +
            "'>";
          bundle_html +=
            '<div class="clearfix swatch-type-min-' +
            o.name.toLowerCase() +
            '" data-option-index="' +
            option_index +
            '">';

          if (already_added_visor_name === "Glossy Black") {
            // Hack to make skyline gray use glossy black that's not avail in products
            bundle_html += '<div class="included-visor-section">';
            bundle_html +=
              '<div class="option_title_already included-visor-text">';
            bundle_html +=
              '<span class="swatch-type"> VISOR INCLUDED WITH PURCHASE </span>';
            bundle_html += "</div>";
            bundle_html +=
              '<div class="option_title_already included-visor-text1">';
            bundle_html +=
              '<span class="swatch-type"> * One Visor is included in the helmet purchase  </span>';
            bundle_html += "</div>";
            bundle_html += `<div class="option_title_already included-visor-image"><div class=""><div data-id="32709655199791" class="swatch-min-element available color matte-black-swatch"><label><img class="crossed-out" src="//cdn.shopify.com/s/files/1/0836/6919/t/306/assets/soldout_small.png?v=26608208942692023401663709985"></label></div></div><span class="swatch-type"> Glossy Black </span></div>`;

            bundle_html += "</div>";
            // End hack
          } else if (typeof already_added_visor_details.id != "undefined") {
            var added_element_class =
              handleize(already_added_visor_details.title) + "-swatch";
            bundle_html += '<div class="included-visor-section">';
            bundle_html +=
              '<div class="option_title_already included-visor-text">';
            bundle_html +=
              '<span class="swatch-type"> VISOR INCLUDED WITH PURCHASE </span>';
            bundle_html += "</div>";
            bundle_html +=
              '<div class="option_title_already included-visor-text1">';
            bundle_html +=
              '<span class="swatch-type"> * One Visor is included in the helmet purchase  </span>';
            bundle_html += "</div>";
            bundle_html +=
              '<div class="option_title_already included-visor-image">';
            bundle_html += '<div class="">';
            bundle_html +=
              '<div data-id="' +
              already_added_visor_details.id +
              '" class="swatch-min-element available color ' +
              added_element_class +
              '">';
            bundle_html += "<label>";
            bundle_html +=
              '<img class="crossed-out" src="' + assetsoldoutUrl + '">';
            bundle_html += "</label></div></div>";
            bundle_html +=
              '<span class="swatch-type"> ' +
              already_added_visor_details.title +
              " </span>";
            bundle_html += "</div>";
            bundle_html += "</div>";
          }

          bundle_html += '<div class="option_title">';

          bundle_html +=
            '<span  data-name="' +
            o.name.toLowerCase() +
            '" class="swatch-type">ADD A SECOND VISOR</span>';

          if (is_color_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-color-min"></span>';
          } else if (is_size_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-size-min"></span>';
          } else if (is_style_min) {
            bundle_html +=
              '<span class="swatch-seperator"> - </span> <span class="current-style-min"></span>';
          }

          bundle_html += '<span class="kit-builder-price visor-price"> </span>';

          bundle_html += "</div>";

          bundle_html += '<div class="visor-error" style="display:none">';
          bundle_html +=
            '<span class="visor-error-message">*Previous Visor is the same color*</span>';
          bundle_html += "</div>";

          var options_values = o.values;
          var check_var_opt = [];
          $.each(product.variants, function (k, v) {
            var op = option_index + 1;
            var op_index = "option" + op;
            if (options_values.includes(v[op_index])) {
              if (!check_var_opt.includes(v[op_index])) {
                check_var_opt.push(v[op_index]);
                var soldClass = v.available ? "available" : "soldout";
                var imageUrl =
                  typeof v.featured_image.src != "undefined"
                    ? v.featured_image.src
                    : "";
                var checked = k == 0 ? "checked" : "";
                var handle = v[op_index]
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "");
                if (is_size_min) {
                  var element_class = "size " + handle + "-swatch";
                } else if (is_style_min) {
                  var element_class = "style " + handle + "-swatch";
                } else if (is_color_min) {
                  var element_class = "color " + handle + "-swatch";
                }

                bundle_html += '<div class = "swatch-min-item">';
                if (is_size_min) {
                  bundle_html +=
                    '<input id="option-' +
                    v.id +
                    '" type="radio" data-value="' +
                    v[op_index] +
                    '" data-product_id="' +
                    product.id +
                    '" data-id="' +
                    v.id +
                    '" data-is-color="' +
                    is_color_min +
                    '" data-variant-name="' +
                    v.title +
                    '" name="product-option-' +
                    option_index +
                    '" value="' +
                    v[op_index] +
                    '" ' +
                    checked +
                    ' class="' +
                    soldClass +
                    '" />';
                } else {
                  bundle_html +=
                    '<input id="option-' +
                    v.id +
                    '" type="radio" data-value="' +
                    v[op_index] +
                    '" data-product_id="' +
                    product.id +
                    '" data-id="' +
                    v.id +
                    '" data-is-color="' +
                    is_color_min +
                    '" data-variant-name="' +
                    v.title +
                    '" name="product-option-' +
                    option_index +
                    '" value="' +
                    v[op_index] +
                    '" ' +
                    checked +
                    ' class="' +
                    soldClass +
                    '" data-image="' +
                    imageUrl +
                    '" />';
                }

                bundle_html +=
                  '<div data-id="' +
                  v.id +
                  '" class="swatch-min-element ' +
                  soldClass +
                  " " +
                  element_class +
                  '">';
                bundle_html += '<label for = "option-' + v.id + '">';
                if (is_size_min) {
                  if (v[op_index] == "Small") {
                    bundle_html +=
                      '<span class="swatch-display-min"> S </span>';
                  } else if (v[op_index] == "Medium") {
                    bundle_html +=
                      '<span class="swatch-display-min"> M </span>';
                  } else if (v[op_index] == "Large") {
                    bundle_html +=
                      '<span class="swatch-display-min"> L </span>';
                  } else if (v[op_index] == "Extra Small") {
                    bundle_html +=
                      '<span class="swatch-display-min"> XS </span>';
                  } else if (v[op_index] == "Extra Large") {
                    bundle_html +=
                      '<span class="swatch-display-min"> XL </span>';
                  }
                }
                bundle_html +=
                  '<img class="crossed-out" src="' + assetsoldoutUrl + '"/>';
                bundle_html += "</label>";
                bundle_html += "</div>";
                bundle_html += "</div>";
              }
            }
          });
          bundle_html += "</div>";
          bundle_html += "</div>";
        });

        var varient_id, sold_out;
        jQuery("#visor").find(".bike-visor").html(bundle_html);

        if (typeof kitBuilderInfoDisc[product.id] != "undefined") {
          jQuery("#visor")
            .find(".about-visor")
            .html(kitBuilderInfoDisc[product.id].dec);
        } else {
          jQuery("#visor").find(".about-visor").html("");
        }

        varient_id = jQuery("#visor")
          .find(".bundle-product-options-visor")
          .find("input")
          .first()
          .data("id");
        sold_out = jQuery("#visor")
          .find(".bundle-product-options-visor")
          .find("input")
          .first()
          .hasClass("soldout")
          ? true
          : false;

        let varient_name = jQuery("#visor")
          .find(".bundle-product-options-visor")
          .find("input")
          .first()
          .data("value");
        let type = jQuery("#visor")
          .find(".bundle-product-options-visor")
          .find(".option_title .swatch-type")
          .data("name");

        if (varient_name == already_added_visor_details.title) {
          $(".visor-error").show();
        } else {
          $(".visor-error").hide();
        }

        if (type == "Style" || type == "style") {
          jQuery("#visor")
            .find(".bundle-product-options-visor")
            .find(".option_title .current-style-min")
            .text(varient_name);
        } else if (type == "Color" || type == "color") {
          jQuery("#visor")
            .find(".bundle-product-options-visor")
            .find(".option_title .current-color-min")
            .text(varient_name);
        } else if (type == "Size" || type == "size") {
          jQuery("#visor")
            .find(".bundle-product-options-visor")
            .find(".option_title .current-size-min")
            .text(varient_name);
        }

        jQuery("#visor")
          .find(".bundle-product-options-visor")
          .find("input")
          .first()
          .prop("checked", true);

        if (typeof cart_bundle_cookie.visor != "undefined") {
          $(".bundle-product-options-visor")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.visor.color +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-visor")
            .find(
              'input[name=product-option-0][value="' +
                cart_bundle_cookie.visor.color +
                '"]'
            )
            .trigger("change");
        } else if (typeof edited_products.visor != "undefined") {
          $(".bundle-product-options-visor")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.visor.variant_options[0] +
                '"]'
            )
            .prop("checked", true);
          $(".bundle-product-options-visor")
            .find(
              'input[name=product-option-0][value="' +
                edited_products.visor.variant_options[0] +
                '"]'
            )
            .trigger("change");
        } else {
          all_varients = product.variants;
          all_varients.forEach(function (item, index) {
            if (item.id == varient_id) {
              selected_visor_varient_details = item;
            }
          });

          var visor_varient_images = get_visor_image(
            varient_name,
            visor_all_images
          );

          if (selected_helmet_varient_color == "Club Navy") {
            selected_helmet_varient_visor_image = visor_varient_images[2];
          } else if (selected_helmet_varient_color == "Racer Black") {
            selected_helmet_varient_visor_image = visor_varient_images[1];
          } else if (selected_helmet_varient_color == "Supermoon White") {
            selected_helmet_varient_visor_image = visor_varient_images[3];
          } else {
            selected_helmet_varient_visor_image = visor_varient_images[0];
          }

          if (
            selected_helmet_varient_visor_image != "" &&
            typeof selected_helmet_varient_visor_image != "undefined"
          ) {
            $(".kit-visor-image").remove();
            var visor_image =
              '<span class="builder-bg-img kit-product-image2 kit-monogram-image kit-visor-image"><img class="kit-helmet" src="' +
              selected_helmet_varient_visor_image +
              '"><span>';
            $(".kit-builder-img").append(visor_image);
          }

          var itemPrice = check_visor_strikethrough_price(cart_bundle_cookie);
          $("#visor")
            .find(".visor-price")
            .html(
              '<span class="money">' + itemPrice + "</strong></div></a></li>"
            );
          ValidateProductQtyForNextStep(
            selected_visor_varient_details.id,
            "visor"
          );
        }

        hide_loader();
      }
    );
  }

  function check_visor_strikethrough_price(cart_bundle_cookie) {
    var itemPrice;
    var strikethrough_discount = false;
    var dis_price = selected_visor_varient_details.price;

    if (
      strikethrough_discounted_price.chapter_visors.dis_price != "" &&
      strikethrough_visibility_rideshop == "true"
    ) {
      if (mips_helmet) {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.chapter_visors.dis_price;
      } else if (typeof cart_bundle_cookie.helmet != "undefined") {
        strikethrough_discount = true;
        dis_price = strikethrough_discounted_price.chapter_visors.dis_price;
      }
    }
    selected_visor_varient_details.bprice = dis_price;
    var itemPrice = formatMoneyStripTrailingZeros(
      dis_price,
      $("body").data("money-format")
    );
    if (strikethrough_discount) {
      itemPrice +=
        '<span class="money was_price">' +
        formatMoneyStripTrailingZeros(
          selected_visor_varient_details.price,
          $("body").data("money-format")
        ) +
        "</span>";
    }
    return itemPrice;
  }

  //   on visor variation change
  $(document).on(
    "change",
    ".bundle-product-options-visor input[type=radio]",
    function () {
      $(".kit-next-btn").text("Add to Bundle").attr("disabled", false);

      var current_element = $(this);
      let cart_bundle_cookie =
        typeof getCookie("bundle_cart_elements") == "undefined" ||
        getCookie("bundle_cart_elements") == ""
          ? {}
          : $.parseJSON(getCookie("bundle_cart_elements"));

      let varient_name = $(this).data("value");
      let type = $(this)
        .parents(".bundle-product-options-visor")
        .find(".option_title .swatch-type")
        .data("name");

      if (varient_name == already_added_visor_details.title) {
        $(".visor-error").show();
      } else {
        $(".visor-error").hide();
      }

      if (type == "Color" || type == "color") {
        $(this)
          .parents(".bundle-product-options-visor")
          .find(".option_title .current-color-min")
          .text(varient_name);
      }

      let varient_id = "";
      let sold_out = false;
      let varients = $(this)
        .parents(".bundle-product-options-visor")
        .data("varients");

      if (isJson(varients)) {
        varients = JSON.parse(JSON.parse(varients));
      }

      varient_id = $(this).data("id");
      sold_out = $(this).hasClass("soldout") ? true : false;

      var price = 0;
      varients.forEach(function (item, index) {
        if (item.id == varient_id) {
          selected_visor_varient_details = item;
        }
      });

      var visor_varient_images = get_visor_image(
        varient_name,
        visor_all_images
      );

      if (selected_helmet_varient_color == "Club Navy") {
        selected_helmet_varient_visor_image = visor_varient_images[2];
      } else if (selected_helmet_varient_color == "Racer Black") {
        selected_helmet_varient_visor_image = visor_varient_images[1];
      } else if (selected_helmet_varient_color == "Supermoon White") {
        selected_helmet_varient_visor_image = visor_varient_images[3];
      } else {
        selected_helmet_varient_visor_image = visor_varient_images[0];
      }

      if (
        selected_helmet_varient_visor_image != "" &&
        typeof selected_helmet_varient_visor_image != "undefined"
      ) {
        $(".kit-visor-image").remove();
        var visor_image =
          '<span class="builder-bg-img kit-product-image2 kit-monogram-image kit-visor-image"><img class="kit-helmet" src="' +
          selected_helmet_varient_visor_image +
          '"><span>';
        $(".kit-builder-img").append(visor_image);
      }

      var itemPrice = check_visor_strikethrough_price(cart_bundle_cookie);
      $("#visor")
        .find(".visor-price")
        .html('<span class="money">' + itemPrice + "</strong></div></a></li>");
      ValidateProductQtyForNextStep(selected_visor_varient_details.id, "visor");
    }
  );

  function ValidateProductQtyForNextStep(varient_id, name) {
    if (typeof kitBuilderInfo[varient_id] != "undefined") {
      if (kitBuilderInfo[varient_id][inv_location] < 1) {
        $(".kit-next-btn").text("Out of Stock").attr("disabled", true);
      }
    } else {
      $(".kit-next-btn").text("Out of Stock").attr("disabled", true);
      console.log("QTY not found");
    }
  }

  // get Monogram tab html
  function get_products_monogram(handle) {
    let cart_bundle_cookie =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    var bundle_html = "";

    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + handle + ".js",
      function (product) {
        selected_monogram_product_details = product;

        var all_varients = product.variants;
        var variantStyleArr = [];
        var variantFinishArr = [];
        var variantFinishArrPrice = [];

        all_varients.forEach(function (varient, varient_index) {
          if (!variantStyleArr.includes(varient.option1)) {
            variantStyleArr.push(varient.option1);
          }
          if (!variantFinishArr.includes(varient.option2)) {
            variantFinishArr.push(varient.option2);
            variantFinishArrPrice.push(varient.price);
          }
        });

        bundle_html += '<div class="builder__steps-wrapper">';
        bundle_html += '<div class="builder__steps">';

        bundle_html += '<div class="builder__style">';
        bundle_html += '<p class="">';
        bundle_html += '<span class="weight--md">';
        bundle_html += '<span class="weight--md"> 1. Choose your style ';
        bundle_html +=
          '</span> - <span class="builder__selected-style"></span> <span class="builder__letters-help"> (<span class="builder__amount-letters">3 Letters</span></span>) <span class="builder__selected-finish-price product-price kit-builder-price"></span></p>';
        variantStyleArr.forEach(function (style, index) {
          bundle_html += '<div class="builder__style-variant">';
          bundle_html +=
            '<input type="radio" data-variant-info="' +
            style +
            '" name="style" id="' +
            handleize(style) +
            '">';
          bundle_html +=
            '<label for="' +
            handleize(style) +
            '" class="builder__style-swatch builder__style-swatch--' +
            handleize(style) +
            '">';
          bundle_html +=
            '<img src="' +
            baseFilePath +
            "/style-" +
            handleize(style) +
            '.svg" alt="">';
          bundle_html += "</label>";
          bundle_html += "</div>";
        });

        bundle_html += "</div>";

        bundle_html += '<div class="builder__letters">';
        bundle_html +=
          '<p class="weight--md "> 2. Enter Your Letter(s) <span class="letters__error"></span></p>';
        bundle_html += '<div class="builder__letters-input">';
        bundle_html += '<input type="text" maxlength="3" placeholder="THS" />';
        bundle_html += "</div>";
        bundle_html += "</div>";

        bundle_html += '<div class="builder__finish">';
        bundle_html +=
          '<p class=""><span class="weight--md">3. Choose your finish</span> - <span class="builder__selected-finish"></span> (<span class="builder__selected-finish-price"></span>)</p>';

        variantFinishArr.forEach(function (finish, index) {
          var price = formatMoneyStripTrailingZeros(
            variantFinishArrPrice[index],
            $("body").data("money-format")
          );
          bundle_html += '<div class="builder__finish-variant">';
          bundle_html +=
            '<input type="radio" data-variant-info="' +
            finish +
            '" data-variant-price="' +
            price +
            '" name="finish" id="' +
            handleize(finish) +
            '">';
          bundle_html +=
            '<label for="' +
            handleize(finish) +
            '" class="builder__finish-swatch builder__finish-swatch--' +
            handleize(finish) +
            '">';
          bundle_html +=
            '<span> <img src="' +
            baseFilePath +
            "/thousand-heritage-monogram-" +
            handleize(finish) +
            '-swatch-sm.jpg" alt=""></span>';
          bundle_html += "</label>";
          bundle_html += "</div>";
        });

        bundle_html += "</div>";
        bundle_html += "</div>";
        bundle_html += "</div>";

        jQuery("#monogram").find(".kit-tab-content-box").html(bundle_html);

        if ($("#sunburst").length) {
          $("#sunburst").attr("data-tbimg", selected_helmet_varient_color);
        }

        if (typeof cart_bundle_cookie.monogram != "undefined") {
          $(".builder__style")
            .find(
              'input[name=style][data-variant-info="' +
                cart_bundle_cookie.monogram.style +
                '"]'
            )
            .click();
          $(".builder__finish")
            .find(
              'input[name=finish][data-variant-info="' +
                cart_bundle_cookie.monogram.finish +
                '"]'
            )
            .click();
          $(".builder__letters-input input").val(
            cart_bundle_cookie.monogram.initials
          );
          selected_monogram_initials = cart_bundle_cookie.monogram.initials;
        } else if (typeof edited_products.monogram != "undefined") {
          $(".builder__style")
            .find(
              'input[name=style][data-variant-info="' +
                edited_products.monogram.variant_options[0] +
                '"]'
            )
            .click();
          $(".builder__finish")
            .find(
              'input[name=finish][data-variant-info="' +
                edited_products.monogram.variant_options[1] +
                '"]'
            )
            .click();
          $(".builder__letters-input input").val(
            edited_products.monogram.properties.Initials
          );
          selected_monogram_initials =
            edited_products.monogram.properties.Initials;
        } else {
          jQuery(".builder__style").find("input").first().click();
          jQuery(".builder__finish").find("input").first().click();
        }

        hide_loader();
      }
    );
  }

  // on change monogram style variant
  $(document).on("change", ".builder__style input[type=radio]", function () {
    if ($(".kit-monogram-image").length == 0) {
      set_monogram_image();
    }
    var monogramStyle = $(this).attr("data-variant-info");
    $(".builder__letters-input input").val("");
    var LengthText = "";
    $(".builder__selected-style, .monogram-title__style").text(monogramStyle);

    var dummy_text = "";
    if (monogramStyle === "Diamond") {
      maxLengthMonogram = 1;
      LengthText = "1 Letter";
      dummy_text = "<span>T</span>";
    } else if (monogramStyle === "Lightning Bolt") {
      maxLengthMonogram = 2;
      LengthText = "2 Letters";
      dummy_text = "<span>T</span><span>H</span>";
    } else if (monogramStyle === "Sunburst") {
      maxLengthMonogram = 1;
      LengthText = "1 Letter";
      dummy_text = "<span>T</span>";
    } else {
      maxLengthMonogram = 3;
      LengthText = "3 Letters";
      dummy_text = "<span>T</span><span>H</span><span>S</span>";
    }

    $(".monogram-display-letters").html(dummy_text);
    var defaultLetters = "THS";
    var defaultInitialsSliced = defaultLetters.slice(0, maxLengthMonogram);
    $(".builder__amount-letters").text(LengthText);
    $(".builder__letters-input input").attr(
      "placeholder",
      defaultInitialsSliced
    );
    $(".builder__letters-input input").attr("maxlength", maxLengthMonogram);
    $(".monogram-display").attr("data-style", handleize(monogramStyle));
    var monogramFinish = $(".builder__finish input[type=radio]:checked").attr(
      "data-variant-info"
    );
    updateMonogramImage(monogramStyle, monogramFinish);
  });

  // on change monogram finish variant
  $(document).on("change", ".builder__finish input[type=radio]", function () {
    if ($(".kit-monogram-image").length == 0) {
      set_monogram_image();
    }
    var monogramFinish = $(this).attr("data-variant-info");
    var monogramFinishPrice = $(this).attr("data-variant-price");
    $(".builder__selected-finish, .monogram-title__finish").text(
      monogramFinish
    );
    $(".builder__selected-finish-price").text(monogramFinishPrice);
    $(".monogram-display").attr("data-finish", handleize(monogramFinish));
    var monogramStyle = $(".builder__style input[type=radio]:checked").attr(
      "data-variant-info"
    );
    updateMonogramImage(monogramStyle, monogramFinish);
  });

  // on change monogram letter variant
  $(document).on("input", ".builder__letters-input input", function (e) {
    var disallowedCharsRegex = /[^A-Za-z]/g;
    var isDisallowedChar = disallowedCharsRegex.test(e.target.value);
    e.target.value = e.target.value
      .toUpperCase()
      .replace(disallowedCharsRegex, "");
    if (isDisallowedChar) {
      $(".letters__error").text("Please use letters only");
      $(".letters__error").addClass("is-error").focus();
    } else {
      $(".letters__error").text("");
      $(".letters__error").removeClass("is-error");
    }
    var monogramSpanInitials;
    selected_monogram_initials = e.target.value;
    monogramSpanInitials = selected_monogram_initials.replace(
      /(.)/g,
      "<span>$1</span>"
    );
    $(".monogram-display-letters").html(monogramSpanInitials);
  });

  function updateMonogramImage(monogramStyle, monogramFinish) {
    $(".monogram-display-letters").attr("data-htype", "");
    if (!monogramStyle || !monogramFinish) {
      return;
    }
    if (monogramStyle === "Zig Zag") {
      $(".monogram-display-letters").css("background-image", "none");
      return;
    }
    var imgPath =
      baseFilePath +
      "thousand-monogram-" +
      handleize(monogramStyle) +
      "-" +
      handleize(monogramFinish) +
      ".png";
    $(".monogram-display-letters").css(
      "background-image",
      "url(" + imgPath + ")"
    );
    if (monogramStyle === "Sunburst") {
      $(".monogram-display-letters").attr(
        "data-htype",
        $("#sunburst").attr("data-tbimg")
      );
      return;
    }
  }

  function get_already_added_visor_details(visor_varients, visor_name) {
    var visor_details = [];
    visor_varients.forEach(function (item, index) {
      if (item.title == visor_name) {
        visor_details = item;
      }
    });
    return visor_details;
  }

  function get_visor_image(visor_varient_name, visor_all_images) {
    var visor_images = [];
    visor_all_images.forEach(function (item, index) {
      if (item.alt == visor_varient_name) {
        visor_images.push(item.src);
      }
    });
    return visor_images;
  }

  $(document).on("click", ".kit-selector li a", function (e) {
    //show div of that tab from this data-kit-tab
    e.preventDefault();

    show_loader();
    current_tab = $(this).data("kit-tab");

    if (current_tab == "helmets") {
      $(".previous-step").hide();
      $(".rideShop-step").addClass("right");
    } else {
      $(".previous-step").show();
      $(".rideShop-step").removeClass("right");
    }

    $(".ths-kit-builder-tab").hide();
    $("#" + current_tab).show();
    $(".kit-tabs-nav li").removeClass("active");
    $(this).parent().addClass("active");

    if (current_tab == "checkout") {
      var edit_bundle = check_edit_kit_mode();
      var button_text = edit_bundle != null ? "UPDATE BUNDLE" : "ADD TO CART";
      $(".kit-next-btn").text(button_text);
      $(".kit-next-btn").addClass("last-step");
      $(".skip-step").hide();
      hide_loader();
    } else {
      $(".kit-next-btn").text("Add to Bundle");
      $(".kit-next-btn").removeClass("last-step");
      $(".skip-step").show();
      set_next_tab();

      var handle = products_kit[selected_helmet][current_tab];

      if (current_tab == "gloves") {
        get_product_info_glove(handle);
      } else if (current_tab == "bells" || current_tab == "stickers") {
        get_products_bells_stickers(handle);
      } else if (current_tab == "socks") {
        get_products_socks(handle);
      } else if (current_tab == "gaiter") {
        get_products_gaiter(handle);
      } else if (current_tab == "remixgloves") {
        get_products_remixgloves(handle);
      } else if (current_tab == "visor") {
        get_products_visor(handle);
      } else if (current_tab == "monogram") {
        get_products_monogram(handle);
      } else if (current_tab == "helmets") {
        get_product_info(selected_helmet);
        if (
          (selected_helmet == "bike-helmet" ||
            selected_helmet == "kids-helmet") &&
          $(".kit-selector .monogram-tab-heading").hasClass("hide")
        ) {
          $(".kit-selector .monogram-tab-heading").removeClass("hide");
          $(".kit-selector .monogram-tab-heading").addClass("show");
          set_next_tab();
        }
        hide_loader();
      } else if (current_tab == "lights") {
        get_products_lights(handle);
      } else if (current_tab == "locks") {
        get_products_locks(handle);
      } else {
        hide_loader();
      }
    }
  });

  $(document).on("click", ".kit-next-btn", function () {
    //add to cart
    var cart_elements =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));

    if (!$(this).hasClass("last-step")) {
      $(".ride-shop-bg").remove();
      $(".previous-step").show();
      $(".rideShop-step").removeClass("right");

      if (current_tab == "helmets") {
        cart_elements.helmet = {
          name: selected_helmet_varient_details.name,
          price: selected_helmet_varient_details.price,
          varient_id: selected_helmet_varient_details.id,
          title: selected_helmet_varient_details.title,
          helmet_type: selected_helmet,
          ptype: current_tab,
          color: selected_helmet_varient_details.option1,
          size: selected_helmet_varient_details.option2,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "monogram") {
        if (is_invalid_monogram()) {
          $(".letters__error").text(
            " - Please enter " +
              (maxLengthMonogram -
                $(".builder__letters-input input").val().length) +
              " more letter(s)"
          );
          $(".letters__error").addClass("is-error").focus();
          return;
        }

        var monogram = get_monogram_variant();

        cart_elements.monogram = {
          name: monogram.name,
          price: monogram.price,
          varient_id: monogram.id,
          initials: selected_monogram_initials,
          ptype: current_tab,
          style: monogram.option1,
          finish: monogram.option2,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "visor") {
        if ($(".visor-error").css("display") == "block") {
          return;
        }

        cart_elements.visor = {
          name: selected_visor_varient_details.name,
          price: selected_visor_varient_details.price,
          bprice: selected_visor_varient_details.bprice,
          varient_id: selected_visor_varient_details.id,
          ptype: current_tab,
          color: selected_visor_varient_details.option1,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "gloves") {
        cart_elements.gloves = {
          name: selected_glove_varient_details.name,
          price: selected_glove_varient_details.price,
          bprice: selected_glove_varient_details.bprice,
          varient_id: selected_glove_varient_details.id,
          ptype: current_tab,
          style: selected_glove_varient_details.option1,
          size: selected_glove_varient_details.option2,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "bells") {
        cart_elements.bells = {
          name: selected_bells_varient_details.name,
          price: selected_bells_varient_details.price,
          bprice: selected_bells_varient_details.bprice,
          varient_id: selected_bells_varient_details.id,
          ptype: current_tab,
          option: selected_bells_varient_details.option1,
          handle: selected_bells_varient_handle,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "socks") {
        cart_elements.socks = {
          name: selected_socks_varient_details.name,
          price: selected_socks_varient_details.price,
          bprice: selected_socks_varient_details.bprice,
          varient_id: selected_socks_varient_details.id,
          ptype: current_tab,
          option: selected_socks_varient_details.option1,
          handle: selected_socks_varient_handle,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "gaiter") {
        cart_elements.gaiter = {
          name: selected_gaiter_varient_details.name,
          price: selected_gaiter_varient_details.price,
          bprice: selected_gaiter_varient_details.bprice,
          varient_id: selected_gaiter_varient_details.id,
          ptype: current_tab,
          option: selected_gaiter_varient_details.option1,
          handle: selected_gaiter_varient_handle,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "remixgloves") {
        cart_elements.remixgloves = {
          name: selected_remixgloves_varient_details.name,
          price: selected_remixgloves_varient_details.price,
          bprice: selected_remixgloves_varient_details.bprice,
          varient_id: selected_remixgloves_varient_details.id,
          ptype: current_tab,
          option: selected_remixgloves_varient_details.option1,
          handle: selected_remixgloves_varient_handle,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "stickers") {
        cart_elements.stickers = {
          name: selected_sticker_varient_details.name,
          price: selected_sticker_varient_details.price,
          bprice: selected_sticker_varient_details.bprice,
          varient_id: selected_sticker_varient_details.id,
          ptype: current_tab,
          option: selected_sticker_varient_details.option1,
          handle: selected_sticker_varient_handle,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "lights") {
        cart_elements.lights = {
          name: selected_lights_varient_details.name,
          price: selected_lights_varient_details.price,
          bprice: selected_lights_varient_details.bprice,
          varient_id: selected_lights_varient_details.id,
          ptype: current_tab,
          color: selected_lights_varient_details.option1,
          light: selected_lights_varient_details.option2,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      } else if (current_tab == "locks") {
        cart_elements.locks = {
          name: selected_locks_varient_details.name,
          price: selected_locks_varient_details.price,
          bprice: selected_locks_varient_details.bprice,
          varient_id: selected_locks_varient_details.id,
          ptype: current_tab,
          color: selected_locks_varient_details.option1,
          handle: selected_locks_varient_details.handle,
        };

        setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
      }

      if (next_tab == "monogram") {
        set_monogram_image();
      }

      jQuery("a[data-kit-tab=" + current_tab + "]")
        .find(".ride-shop-icon .active-tab-icon")
        .show();
      jQuery("a[data-kit-tab=" + current_tab + "]")
        .find(".ride-shop-icon .idle-tab-icon")
        .hide();
      jQuery("ul.kit-selector")
        .find("[data-kit-tab=" + next_tab + "]")
        .trigger("click");

      var $next = $(".kit-selector .active").next();
      if ($next.length) {
        $(".kit-selector").animate(
          {
            scrollLeft: 100,
          },
          "slow"
        );
      }
    } else {
      $(".previous-step").hide();

      show_loader();

      // check if kit is edit mode and change selected_helmet value
      var edit_bundle = check_edit_kit_mode();

      if (edit_bundle != null) {
        var removedata = { updates: {} };
        for (i = 0; i < edited_products_ids.length; i++) {
          removedata.updates[edited_products_ids[i]] = 0;
        }

        jQuery.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: removedata,
          dataType: "json",
          success: function () {
            var data_items = get_add_to_cart_items_data(
              cart_elements,
              edited_bundle_position
            );
            add_bundle_to_cart(data_items, edited_bundle_position);
          },
        });
      } else {
        var highest_bundle = 0;

        if (cart_products.item_count > 0) {
          $.each(cart_products.items, function (index, item) {
            if (typeof item.properties._btype != "undefined") {
              if (item.properties._bposition >= highest_bundle) {
                highest_bundle = parseInt(item.properties._bposition) + 1;
              }
            }
          });
        }
        var data_items = get_add_to_cart_items_data(
          cart_elements,
          highest_bundle
        );
        add_bundle_to_cart(data_items, highest_bundle);
      }
    }
    create_checkout_summary_tab_html(cart_elements);
    updateUnlockUI(cart_elements);
  });

  function add_bundle_to_cart(data_items, bundle_position) {
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: data_items,
      },
      dataType: "json",
      success: function (response) {
        $.ajax({
          url: "/cart.js",
          dataType: "json",
          cache: false,
          success: function (cart) {
            setCookie("bundle_cart_elements", "", 30);
            refreshCart(cart, true);
            var bsuccess = get_bundle_success_html(cart.items, bundle_position);
            $(".kit-product-tab").html(bsuccess);
            hide_loader();
          },
          fail: function (request, status, error) {
            console.log(status);
            console.log(error);
          },
        });
      },
    });
  }

  function get_bundle_success_html(added_products, bundle_position) {
    var success_html = "";
    success_html = '<div class="bundle_success">';
    success_html += "<h2>The Bundle Has Been Added To Your Cart</h2>";
    success_html += '<div class="kit-checkout contaner">';
    success_html += '<div class="column three">';
    success_html += '<div class="kit-img">';
    success_html +=
      '<img class="kit-ths-img" src="' + baseFilePath + 'bundle_1.png">';
    success_html += "</div></div>";
    success_html += '<div class="column thirteen">';
    success_html += "<table>";
    success_html += "<tbody>";

    var bprice = 0;
    var dprice = 0;
    var array_reverse = added_products.reverse();
    $.each(array_reverse, function (index, item) {
      if (
        typeof item.properties._btype != "undefined" &&
        item.properties._bposition == bundle_position
      ) {
        var productPrice = item.discounted_price / 100;

        bprice += item.price;
        dprice += item.discounted_price;
        var ptitle =
          item.handle == "monogram" || item.handle == "thousand-jr-monogram"
            ? item.title + " / " + item.properties.Initials
            : item.title;
        success_html += "<tr>";
        success_html += "<td> " + ptitle + " </td>";
        success_html += "</tr>";
      }
    });

    success_html += "</tr><tr></tr><tr>";

    success_html += '<tr class="subtotal_checkout">';
    success_html += "<td>SUBTOTAL</td>";

    success_html += "<td>";

    success_html +=
      '<span class="build-orignal-price">' +
      formatMoneyStripTrailingZeros(dprice, $("body").data("money-format")) +
      " </span>";
    if (bprice > dprice) {
      success_html +=
        '<span class="build-discountprice">' +
        formatMoneyStripTrailingZeros(bprice, $("body").data("money-format")) +
        "</span>";
    }

    success_html += "</td>";

    success_html += "</tr>";

    success_html += "</tbody>";
    success_html += "</table>";

    success_html +=
      '<a type="button" href="' +
      kit_page_url +
      "?btype=bp" +
      bundle_position +
      '" class="edit-bundle-btn">EDIT BUNDLE</a>';
    success_html +=
      '<a type="button" href="' +
      kit_page_url +
      '" class="start-bundle-btn">START A NEW BUNDLE</a>';
    success_html += "</div></div></div>";

    return success_html;
  }

  function get_add_to_cart_items_data(cart_elements, highest_bundle) {
    var data_items = [];
    $.each(cart_elements, function (key, value) {
      var properties = {
        _btype: "bp" + highest_bundle,
        _bposition: highest_bundle,
        _ptype: value.ptype,
      };

      if (key == "monogram") {
        properties.Initials = value.initials;
        properties.Helmet = cart_elements.helmet.title;
        properties._image = selected_helmet_varient_monogram_image;
      } else if (key == "visor") {
        properties._image = selected_helmet_varient_visor_image;
      }

      data_items.push({
        quantity: 1,
        id: value.varient_id,
        properties: properties,
      });
    });

    return data_items;
  }

  $(document).on("click", ".tabs-prev", function (e) {
    $(".kit-selector").animate(
      {
        scrollLeft: "-=" + 300,
      },
      "slow"
    );
  });

  $(document).on("click", ".tabs-next", function (e) {
    $(".kit-selector").animate(
      {
        scrollLeft: "+=" + 300,
      },
      "slow"
    );
  });
  //  on click back button
  $(document).on("click", ".previous-step", function (e) {
    e.preventDefault();
    $(".kit-next-btn").attr("disabled", false);
    prev_tab = $("ul.kit-selector li.active")
      .prevAll("li:not(.hide)")
      .first()
      .find("a")
      .data("kit-tab");
    var cart_elements =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));
    if (current_tab == "gloves") {
      if (typeof cart_elements.gloves == "undefined") {
        $(".kit-gloves-image").remove();
      }
    } else if (current_tab == "bells") {
      if (typeof cart_elements.bells == "undefined") {
        $(".kit-bells-image").remove();
      }
    } else if (current_tab == "socks") {
      if (typeof cart_elements.socks == "undefined") {
        $(".kit-socks-image").remove();
      }
    } else if (current_tab == "gaiter") {
      if (typeof cart_elements.gaiter == "undefined") {
        $(".kit-gaiter-image").remove();
      }
    } else if (current_tab == "remixgloves") {
      if (typeof cart_elements.remixgloves == "undefined") {
        $(".kit-remixgloves-image").remove();
      }
    } else if (current_tab == "stickers") {
      if (typeof cart_elements.stickers == "undefined") {
        $(".kit-stickers-image").remove();
      }
    } else if (current_tab == "monogram") {
      if (typeof cart_elements.monogram == "undefined") {
        $(".kit-product-image2").remove();
      }
    } else if (current_tab == "visor") {
      if (typeof cart_elements.visor == "undefined") {
        $(".kit-product-image2").remove();
      }
    } else if (current_tab == "lights") {
      if (typeof cart_elements.lights == "undefined") {
        $(".kit-lights-image").remove();
      }
    } else if (current_tab == "locks") {
      if (typeof cart_elements.locks == "undefined") {
        $(".kit-locks-image").remove();
      }
    }

    if (prev_tab == "helmets") {
      $(".previous-step").hide();
      $(".rideShop-step").addClass("right");
    } else {
      var $prev = $(".kit-selector .active").prev();
      if ($prev.length) {
        $(".kit-selector").animate(
          {
            scrollLeft: $prev.position().left,
          },
          "slow"
        );
      }
    }
    jQuery("ul.kit-selector")
      .find("[data-kit-tab=" + prev_tab + "]")
      .trigger("click");
    updateUnlockUI(cart_elements);
  });

  // on click skip button
  $(document).on("click", ".skip-step", function (e) {
    e.preventDefault();
    $(".ride-shop-bg").remove();
    $(".kit-next-btn").attr("disabled", false);
    $(".previous-step").show();
    $(".rideShop-step").removeClass("right");

    jQuery("a[data-kit-tab=" + current_tab + "]")
      .find(".ride-shop-icon .active-tab-icon")
      .hide();
    jQuery("a[data-kit-tab=" + current_tab + "]")
      .find(".ride-shop-icon .idle-tab-icon")
      .show();

    var cart_elements =
      typeof getCookie("bundle_cart_elements") == "undefined" ||
      getCookie("bundle_cart_elements") == ""
        ? {}
        : $.parseJSON(getCookie("bundle_cart_elements"));

    if (current_tab == "helmets") {
      $(".kit-helmet-image").remove();
      delete cart_elements.helmet;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "gloves") {
      $(".kit-gloves-image").remove();
      delete cart_elements.gloves;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "bells") {
      $(".kit-bells-image").remove();
      delete cart_elements.bells;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "socks") {
      $(".kit-socks-image").remove();
      delete cart_elements.socks;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "gaiter") {
      $(".kit-gaiter-image").remove();
      delete cart_elements.gaiter;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "remixgloves") {
      $(".kit-remixgloves-image").remove();
      delete cart_elements.remixgloves;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "stickers") {
      $(".kit-stickers-image").remove();
      delete cart_elements.stickers;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "monogram" || current_tab == "visor") {
      $(".kit-product-image2").remove();
      delete cart_elements.monogam;
      delete cart_elements.visor;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "lights") {
      $(".kit-lights-image").remove();
      delete cart_elements.lights;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    } else if (current_tab == "locks") {
      $(".kit-locks-image").remove();
      delete cart_elements.locks;
      setCookie("bundle_cart_elements", JSON.stringify(cart_elements), 30);
    }

    if (next_tab == "monogram") {
      $(".kit-monogram-image").remove();
      $(".kit-selector .monogram-tab-heading").addClass("hide");
      set_next_tab();
    } else if (next_tab == "checkout") {
      //rediect to cat page
      create_checkout_summary_tab_html(cart_elements);
    }

    var $next = $(".kit-selector .active").next();
    if ($next.length) {
      $(".kit-selector").animate(
        {
          scrollLeft: $next.position().left,
        },
        "slow"
      );
    }

    jQuery("ul.kit-selector")
      .find("[data-kit-tab=" + next_tab + "]")
      .trigger("click");

    updateUnlockUI(cart_elements);
  });

  $(document).on("click", ".kit-helmet-bundle-select", function () {
    show_loader();
    setCookie("bundle_cart_elements", "", 30);
    remove_kit_images();
    var handle = $(this).val();
    var product_name = $(this).data("name");
    selected_helmet = handle;
    $(this).attr("checked", true);

    $(".kit-selector li").removeClass("hide").addClass("show");
    $('.kit-selector li:not(".' + handle + '")').addClass("hide");
    $(".kit-product-img").removeClass("active");
    $(this).parent().addClass("active");
    $(".all-helmets-select .product-name").text(product_name);
    set_next_tab();
    get_product_info($(this).val());
  });

  function create_checkout_summary_tab_html(cart_elements) {
    var checkout_html = "";
    var total_price = 0;
    var total_dis_price = 0;

    checkout_html += "<table>";

    $.each(cart_elements, function (key, value) {
      var Pprice, name;
      total_price += value.price;

      if (key == "helmet") {
        Pprice = value.price;
        name = value.name;
        total_dis_price += parseInt(value.price);
      } else if (key == "monogram") {
        Pprice = value.price;
        name = value.name + " / " + value.initials;
        total_dis_price += parseInt(value.price);
      } else {
        Pprice = value.bprice;
        name = value.name;
        total_dis_price += parseInt(value.bprice);
      }

      var itemPrice =
        "<span>" +
        formatMoneyStripTrailingZeros(Pprice, $("body").data("money-format")) +
        "</span>";

      checkout_html += "<tr>";
      checkout_html += "<td>" + name + "</td>";
      checkout_html += "<td>" + itemPrice + "</td>";
      checkout_html += "</tr>";
    });
    var itemPriceTotal = "";
    if (total_price > total_dis_price) {
      itemPriceTotal +=
        '<span class="build-discountprice">' +
        formatMoneyStripTrailingZeros(
          total_price,
          $("body").data("money-format")
        ) +
        "</span>";
    }
    itemPriceTotal +=
      '<span class="build-orignal-price">See Savings In Cart <span class="build-slash-price">' +
      formatMoneyStripTrailingZeros(
        total_dis_price,
        $("body").data("money-format")
      ) +
      "</span></span>";
    checkout_html += '<tr class="subtotal_checkout">';
    checkout_html += "<td>SUBTOTAL  </td>";
    checkout_html += "<td>";
    checkout_html += itemPriceTotal;
    checkout_html += "</td>";
    checkout_html += "</tr>";
    checkout_html += "</table>";

    $(".kit-checkout").html(checkout_html);
  }

  // function remove kit
  function remove_kit_images() {
    $(".kit-builder-img").html("");
  }

  // set monogram image
  function set_monogram_image() {
    var monogram_image = "";
    monogram_image +=
      '<span class="builder-bg-img kit-product-image2 kit-monogram-image kit-visor-image">';
    monogram_image += '<div class="monogram__preview-wrapper">';
    monogram_image += '<div class="monogram__image">';
    monogram_image +=
      '<img src="' +
      selected_helmet_varient_monogram_image +
      '" alt="Monogramed Helmet">';
    monogram_image += "</div>";
    monogram_image +=
      '<div class="monogram-display" data-style="diamond" data-finish="gold-leaf">';
    monogram_image +=
      '<div class="monogram-display-letters" data-htype="" style="background-image: url(' +
      baseFilePath +
      'thousand-monogram-diamond-gold-leaf.png&quot;);">';
    monogram_image += "<span>T</span>";
    monogram_image += "</div>";
    monogram_image += "</div>";
    monogram_image += "</div>";
    monogram_image += "</span>";
    $(".kit-builder-img").append(monogram_image);
  }

  // get monogram varient
  function get_monogram_variant() {
    var monogramFinish = $(".builder__finish input[type=radio]:checked").attr(
      "data-variant-info"
    );
    var monogramStyle = $(".builder__style input[type=radio]:checked").attr(
      "data-variant-info"
    );
    var monogramVariant = monogramStyle + " / " + monogramFinish;
    return selected_monogram_product_details.variants.find(function (o) {
      return o.title === monogramVariant;
    });
  }

  // check if valid monogram
  function is_invalid_monogram() {
    var monogramStyle = $(".builder__style input[type=radio]:checked").attr(
      "data-variant-info"
    );
    return (
      $(".builder__letters-input input").val() === "" ||
      (monogramStyle === "Zig Zag" &&
        $(".builder__letters-input input").val().length < 3) ||
      (monogramStyle === "Lightning Bolt" &&
        $(".builder__letters-input input").val().length < 2)
    );
  }
};

const handleQueryStringPreconfig = () => {
  const preconfigLoopkup = {
    chapter: "Chapter",
    heritage: "Heritage",
    jr: "Thousand Jr.",
  };
  const configParams = new URLSearchParams(window.location.search);
  if (!"URLSearchParams" in window || Array.from(configParams).length === -1) {
    return;
  }
  for (const value of configParams.values()) {
    $(`[data-name="${preconfigLoopkup[value]}"]`).click();
  }
};

const updateUnlockUI = (cart_elements) => {
  const accCount = getAccessoryCount(cart_elements);
  if (!cart_elements.helmet) {
    handleUnlockStep(1);
    return;
  }
  if (accCount < 1) {
    handleUnlockStep(2);
    return;
  }
  if (accCount === 1) {
    handleUnlockStep(3);
    return;
  }
  handleUnlockStep(4);
};

const handleUnlockStep = (step) => {
  $(`.unlock-discount__step-${step}`).removeClass("is--locked");
  $(".unlock-discount-text__step").removeClass("is--visible");
  $(`.unlock-discount-text__step-${step}`).addClass("is--visible");
};

const getAccessoryCount = (cart_elements) => {
  const accessoryArray = [
    "locks",
    "lights",
    "stickers",
    "bells",
    "socks",
    "gaiter",
    "remixgloves",
    "gloves",
    "visor",
  ];
  let inCartAccessories = 0;
  accessoryArray.forEach((acc) => {
    cart_elements[acc] && inCartAccessories++;
  });
  return inCartAccessories;
};

$(document).ready(function () {
  bundleProduct();
  // deep link to preconfigured bundle if supported
  handleQueryStringPreconfig();
});

// heritage -> bike-helmet
// Chapter --> mips-helmet
// Jr --> kids-helmet
